<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Ref/Consult/Assessment-{{ organ }}-EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-4 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="transplantProgram"
              class="transplantProgram"
              disabled
              label="Transplant Program"
            />
          </div> 
        
          <div class="col-4">
            <ADSTextInput
              v-model="oatsTransplantProgram"
              class="transplantProgram"
              disabled
              label="Transplant Program"
            />
          </div> 
        </div> -->
        <!-- <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="recipientCoordinator"
              disabled
              label="Recipient Coordinator"
            />
          </div> 
          <div class="col-4">
            <ADSTextInput
              v-model="oatsrecipientCoordinator"
              disabled
              label="Recipient Coordinator"
            />
          </div> 
        </div> -->
        <div class="row">
          <div class="col-6">
            <ADSTextInput
              v-model="primaryDiagnosis"
              disabled
              label="Primary Diagnosis-EMR"
              class="primaryDiagnosis"
              :class="{ highlightField: isDifferent(primaryDiagnosis, oatsPrimaryDiagnosis) }"
            />
          </div> 
        </div>

        <div class="row">
          <div class="col-6">
            <ADSTextInput
              v-model="oatsPrimaryDiagnosis"
              disabled
              class="mandatory-field primaryDiagnosis"
              label="Primary Diagnosis-OATS"
            />
          </div> 
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="secondaryDiagnosis"
              disabled
              label="Secondary Diagnosis-EMR"
              class="primaryDiagnosis"
              :class="{ highlightField: isDifferent(secondaryDiagnosis, oatsSecondaryDiagnosis) }"
            />
          </div> 
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="oatsSecondaryDiagnosis"
              disabled
              class="primaryDiagnosis"
              label="Secondary Diagnosis-OATS"
            />
          </div> 
        </div>
        <!-- <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="primaryDiagnosisDate"
              disabled
              label="Primary Diagnosis Date"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsPrimaryDiagnosisDate"
              disabled
              label="Primary Diagnosis Date"
            />
          </div>
        </div> -->
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="referringOrganizationName"
              disabled
              label="Referring Organization Name"
              class="referringOrganizationName"
              :class="{ highlightField: isDifferent(referringOrganizationName, oatsReferringOrganizationName) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsReferringOrganizationName"
              disabled
              class="mandatory-field referringOrganizationName"
              label="Referring Organization Name"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="referringOrganizationType"
              disabled
              label="Referring Organization Type"
              class="referringOrganizationType"
              :class="{ highlightField: isDifferent(referringOrganizationType, oatsReferringOrganizationType) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsReferringOrganizationType"
              disabled
              class="mandatory-field referringOrganizationType"
              label="Referring Organization Type"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="referringHealthCareProfessionalType"
              disabled
              label="Referring Health Care Professional Type"
              class="referringHealthCareProfessionalType"
              :class="{ highlightField: isDifferent(referringHealthCareProfessionalType, oatsReferringHealthCareProfessionalType) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsReferringHealthCareProfessionalType"
              disabled
              class="mandatory-field referringHealthCareProfessionalType"
              label="Referring Health Care Professional Type"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="firstName"
              disabled
              label="Referrer First Name"
              :class="{ highlightField: isDifferent(firstName, oatsFirstName) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsFirstName"
              disabled
              class="mandatory-field"
              label="Referrer First Name"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="lastName"
              disabled
              label="Referrer Last Name"
              :class="{ highlightField: isDifferent(lastName, oatsLastName) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsLastName"
              disabled
              class="mandatory-field"
              label="Referrer Last Name"
            />
          </div>
        </div>


        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="address"
              disabled
              label="Referrer Address-EMR"
              class="address"
              :class="{ highlightField: isDifferent(address, oatsAddress) }"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="oatsAddress"
              class="address mandatory-field"
              disabled
              label="Referrer Address-OATS"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="city"
              disabled
              label="City"
              :class="{ highlightField: isDifferent(city, oatsCity) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsCity"
              disabled
              label="City"
              class="mandatory-field"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="state"
              disabled
              label="Province/State"
              :class="{ highlightField: isDifferent(state, oatsState) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsState"
              disabled
              label="Province/State"
              class="mandatory-field"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="postalCode"
              disabled
              label="Postal Code"
              :class="{ highlightField: isDifferent(postalCode, oatsPostalCode) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsPostalCode"
              disabled
              label="Postal Code"
              class="mandatory-field"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="country"
              disabled
              label="Country"
              :class="{ highlightField: isDifferent(country, oatsCountry) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsCountry"
              disabled
              label="Country"
              class="mandatory-field"
            />
          </div>
        </div>



        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="referralReceivedDate"
              disabled
              label="Referral Received Date"
              :class="{ highlightField: isDifferent(referralReceivedDate, oatsReferralReceivedDate) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsReferralReceivedDate"
              disabled
              class="mandatory-field"
              label="Referral Received Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="referralDecision"
              disabled
              label="Referral Decision"
              :class="{ highlightField: isDifferent(referralDecision, oatsreferralDecision) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsreferralDecision"
              disabled
              class="mandatory-field"
              label="Referral Decision"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="referralDecisionDate"
              disabled
              label="Referral Decision Date"
              :class="{ highlightField: isDifferent(referralDecisionDate, oatsreferralDecisionDate) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsreferralDecisionDate"
              disabled
              class="mandatory-field"
              label="Referral Decision Date"
            />
          </div>
        </div>

        <div class="row">
          <div v-if="referralDecision?.toLowerCase() === 'referral declined' || referralDecision?.toLowerCase() === 'referral cancelled'"
               class="col-4">
            <ADSTextInput
              v-model="referralDecisionReason"
              disabled
              label="Referral Decision Reason (Declined or  Cancelled)"
              :class="{ highlightField: isDifferent(referralDecisionReason, oatsReferralDecisionReason) }"
            />
          </div>
          <div
            v-if="referralDecision?.toLowerCase() !== 'referral declined' && referralDecision?.toLowerCase() !== 'referral cancelled'"
            class="col-4"/>

          <div
            v-if="oatsreferralDecision?.toLowerCase() === 'referral declined' || oatsreferralDecision?.toLowerCase() === 'referral cancelled'"
            class="col-4">
            <ADSTextInput
              v-model="oatsReferralDecisionReason"
              class="referralDecisionReason"
              disabled
              label="Referral Decision Reason (Declined or  Cancelled)"
            />
          </div>
          <div
            v-if="oatsreferralDecision !== 'Referral Declined' && oatsreferralDecision !== 'Referral Cancelled'"
            class="col-4"/>
        </div>

        <div class="row">
          <div
            v-if="consultationDecision?.toLowerCase() === 'consultation completed'"
            class="col-4">
            <ADSTextInput
              v-model="consultationDate"
              disabled
              label="Consultation Date"
              :class="{ highlightField: isDifferent(consultationDate, oatsConsultationDate) }"
            />
          </div>
          <div
            v-if="consultationDecision?.toLowerCase() !== 'consultation completed'"
            class="col-4"
          />

          <div class="col-4" v-if="oatsConsultationDecision?.toLowerCase() === 'consultation completed'">
            <ADSTextInput
              v-model="oatsConsultationDate"
              disabled
              class="mandatory-field"
              label="Consultation Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="consultationDecision"
              disabled
              label="Consultation Decision"
              :class="{ highlightField: isDifferent(consultationDecision, oatsConsultationDecision) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsConsultationDecision"
              disabled
              class="consultationDecision mandatory-field"
              label="Consultation Decision"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4" v-if="consultationDecision?.toLowerCase() === 'consultation cancelled'">
            <ADSTextInput
              v-model="reasonCancelled"
              disabled
              label="Reason (for Cancelled)"
              :class="{ highlightField: isDifferent(reasonCancelled, oatsReasonCancelled) }"
            />
          </div>
          <div class="col-4" v-if="consultationDecision?.toLowerCase() !== 'consultation cancelled'">
          </div>

          <div class="col-4" v-if="oatsConsultationDecision?.toLowerCase() === 'consultation cancelled'">
            <ADSTextInput
              v-model="oatsReasonCancelled"
              disabled
              label="Reason (for Cancelled)"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4" v-if="consultationDecision?.toLowerCase() === 'consultation cancelled'">
            <ADSTextInput
              v-model="consultationCancelledDate"
              disabled
              label="Consultation Cancelled Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4" v-if="consultationDecision?.toLowerCase() === 'consultation delayed'">
            <ADSTextInput
              v-model="reasonDelayed"
              disabled
              label="Reason (for Delayed)"
              :class="{ highlightField: isDifferent(reasonDelayed, oatsReasonDelayed) }"
            />
          </div>
          <div class="col-4" v-if="consultationDecision?.toLowerCase() !== 'consultation delayed'">
          </div>

          <div class="col-4" v-if="oatsConsultationDecision?.toLowerCase() === 'consultation delayed'">
            <ADSTextInput
              v-model="oatsReasonDelayed"
              disabled
              label="Reason (for Delayed)"
            />
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="primaryTransplantPhysician"
              disabled
              label="Primary Transplant Physician"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsPrimaryTransplantPhysician"
              disabled
              label="Primary Transplant Physician"
            />
          </div>
        </div> -->

        <div class="row">
          <div class="col-4" v-if="consultationDecision?.toLowerCase() === 'consultation delayed'">
            <ADSTextInput
              v-model="consultationDelayStartDate"
              disabled
              label="Consultation Delay Start Date"
              :class="{ highlightField: isDifferent(consultationDelayStartDate, oatsConsultationDelayStartDate) }"
            />
          </div>
          <div class="col-4" v-if="consultationDecision?.toLowerCase() !== 'consultation delayed'">
          </div>

          <div class="col-4" v-if="oatsConsultationDecision?.toLowerCase() === 'consultation delayed'">
            <ADSTextInput
              v-model="oatsConsultationDelayStartDate"
              disabled
              label="Consultation Delay Start Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4" v-if="consultationDecision?.toLowerCase() === 'consultation delayed'">
            <ADSTextInput
              v-model="consultationDelayEndDate"
              disabled
              label="Consultation Delay End Date"
              :class="{ highlightField: isDifferent(consultationDelayEndDate, oatsConsultationDelayEndDate) }"
            />
          </div>
          <div class="col-4" v-if="consultationDecision?.toLowerCase() !== 'consultation delayed'">
          </div>

          <div class="col-4" v-if="oatsConsultationDecision?.toLowerCase() === 'consultation delayed'">
            <ADSTextInput
              v-model="oatsConsultationDelayEndDate"
              disabled
              label="Consultation Delay End Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="consultationComments"
              disabled
              label="Consultation Comments"
              class="consultationComments"
              :class="{ highlightField: isDifferent(consultationComments, oatsConsultationComments) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsConsultationComments"
              disabled
              label="Consultation Comments"
              class="consultationComments"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="assessmentDate"
              disabled
              label="Assessment Date"
              :class="{ highlightField: isDifferent(assessmentDate, oatsAssessmentDate) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsAssessmentDate"
              class="mandatory-field"
              disabled
              label="Assessment Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="assessmentDecision"
              disabled
              label="Assessment Decision"
              class="assessmentDecision"
              :class="{ highlightField: isDifferent(assessmentDecision, oatsAssessmentDecision) }"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsAssessmentDecision"
              disabled
              class="mandatory-field assessmentDecision"
              label="Assessment Decision"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() === 'assessment cancelled'">
            <ADSTextInput
              v-model="reasonAssessmentCancelled"
              disabled
              label="Reason (for Assessment Cancelled)"
              :class="{ highlightField: isDifferent(reasonAssessmentCancelled, oatsReasonAssessmentCancelled) }"
            />
          </div>
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() !== 'assessment cancelled'">
          </div>
          <div class="col-4" v-if="String( oatsAssessmentDecision || '' )?.toLowerCase() === 'assessment cancelled'">
            <ADSTextInput
              v-model="oatsReasonAssessmentCancelled"
              disabled
              label="Reason (for Assessment Cancelled)"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() === 'recipient not eligible for transplant'">
            <ADSTextInput
              v-model="reasonRecipientNotEligible"
              disabled
              label="Reason (for Decision for Recipient not Eligible)"
              :class="{ highlightField: isDifferent(reasonRecipientNotEligible, oatsReasonRecipientNotEligible) }"
              class="reasonRecipientNotEligible"
            />
          </div>
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() !== 'recipient not eligible for transplant'"></div>
          <div class="col-4" v-if="String( oatsAssessmentDecision || '' )?.toLowerCase() === 'recipient not eligible for transplant'">
            <ADSTextInput
              v-model="oatsReasonRecipientNotEligible"
              disabled
              label="Reason (for Decision for Recipient not Eligible)"
              class="reasonRecipientNotEligible"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() === 'further treatment/testing required'">
            <ADSTextInput
              v-model="reasonFurtherTreatment"
              disabled
              label="Reason (for Further Treatment or Further Testing Required)"
              :class="{ highlightField: isDifferent(reasonFurtherTreatment, oatsReasonFurtherTreatment) }"
            />
          </div>
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() !== 'further treatment/testing required'"></div>
          <div class="col-4" v-if="String( oatsAssessmentDecision || '' )?.toLowerCase() === 'further treatment/testing required'">
            <ADSTextInput
              v-model="oatsReasonFurtherTreatment"
              disabled
              label="Reason (for Further Treatment or Further Testing Required)"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() === 'further treatment/testing required'">
            <ADSTextInput
              v-model="other"
              disabled
              label="Other"
              :class="{ highlightField: isDifferent(other, oatsOther) }"
            />
          </div>
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() !== 'further treatment/testing required'"></div>

          <div class="col-4" v-if="String( oatsAssessmentDecision || '' )?.toLowerCase() === 'further treatment/testing required'">
            <ADSTextInput
              v-model="oatsOther"
              disabled
              label="Other"
            />
          </div>
        </div>
        
        <div class="row">
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() === 'recipient not eligible for transplant'">
            <ADSTextInput
              v-model="absoluteContraindication"
              disabled
              label="Absolute Contraindications"
              :class="{ highlightField: isDifferent(absoluteContraindication, oatsAbsoluteContraindication) }"
              class="relativeContraindication"
            />
          </div>
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() !== 'recipient not eligible for transplant'"></div>
          
          <div class="col-4" v-if="String( oatsAssessmentDecision || '' )?.toLowerCase() === 'recipient not eligible for transplant'">
            <ADSTextInput
              v-model="oatsAbsoluteContraindication"
              disabled
              label="Absolute Contraindications"
              class="relativeContraindication"
            />
          </div>
        </div>

        <div class="row" v-if="( organ !== 'Liver' && organ !== 'Intestine' )">
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() === 'recipient not eligible for transplant'">
            <ADSTextInput
              v-model="relativeContraindication"
              disabled
              label="Relative Contraindications"
              :class="{ highlightField: isDifferent(relativeContraindication, oatsRelativeContraindication) }"
              class="relativeContraindication"
            />
          </div>
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() !== 'recipient not eligible for transplant'"></div>
          <div class="col-4" v-if="String( oatsAssessmentDecision || '' )?.toLowerCase() === 'recipient not eligible for transplant'">
            <ADSTextInput
              v-model="oatsRelativeContraindication"
              disabled
              label="Relative Contraindications"
              class="relativeContraindication"
            />
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="comments"
              disabled
              label="Comments"
            />
          </div>

          <div class="col-4">
            <ADSTextInput
              v-model="oatsComments"
              disabled
              label="Comments"
            />
          </div>
        </div> -->
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import { PATIENT_TYPES, ORGAN_LIST } from '@/constants';
// import { ADSTextInput } from '@afflo/afflo-design-system';
import _ from 'lodash';

/** Matches TGLN value_conversions FOLLOWUP_SOURCE (referring organization type codes). */
const REFERRING_ORGANIZATION_TYPE_BY_CODE = {
  1: 'Acute Care hospital',
  2: 'FAMILY PRACTICE',
  3: 'SPECIALIST PRACTICE',
  4: 'TRANSPLANT PROGRAM',
  5: 'COMMUNITY CARE HOSPITAL',
  6: 'DIALYSIS CENTER',
  7: 'CKD AND/OR PRI CLINICS',
  8: 'Other',
};

/** Matches TGLN value_conversions PROFESSIONAL_TYPE (TXP#340 — OATS referring professional type codes). */
const REFERRING_HEALTH_CARE_PROFESSIONAL_TYPE_BY_CODE = {
  1: 'CARDIAC SURGEON',
  2: 'CARDIOLOGIST',
  3: 'ENDOCRINOLOGIST',
  4: 'GASTROENTEROLOGIST',
  5: 'GENERAL AND FAMILY PRACTICE',
  6: 'GENERAL INTERNAL MEDICINE',
  7: 'GENERAL SURGEON',
  8: 'HEMATOLOGIST',
  9: 'HEPATOLOGIST',
  10: 'INFECTIOUS DISEASE',
  11: 'MEDICAL ONCOLOGIST',
  12: 'NEPHROLOGIST',
  13: 'NURSE PRACTITIONER',
  14: 'PAEDIATRICIAN',
  15: 'RESPIROLOGIST',
  16: 'THORACIC SURGEON',
  17: 'UROLOGIST',
  18: 'OTHER',
  19: 'SURGICAL ONCOLOGIST',
  20: 'METABOLIC SPECIALIST',
  21: 'RADIOLOGIST',
};

/** Matches TGLN value_conversions REFERRAL_DECLINED_REASON (internal OATS code → canonical label). */
const REFERRAL_DECLINED_REASON_BY_CODE = {
  1: 'PATIENT DOES NOT MEET REFERRAL CRITERIA',
  2: 'PATIENT REFERRED TO ANOTHER PROGRAM',
  7: 'PATIENT TOO SICK',
  8: 'PATIENT REQUEST',
  9: 'Recipient No longer Requires Transplant due to Recovery',
};

/** Matches TGLN value_conversions REFERRAL_CANCELLED_REASON (internal OATS code → canonical label). */
const REFERRAL_CANCELLED_REASON_BY_CODE = {
  3: 'Recipient death related to organ failure',
  4: 'Recipient death not related to organ failure',
  5: 'Recipient Relocated',
  6: 'Duplicate Referral',
  9: 'Inability To Contact Recipient',
  11: 'Recipient No longer Requires Transplant due to Recovery',
};

/**
 * Matches TGLN value_conversions CONSULTATION_DECISION (TXP#273 — internal code → canonical OATS label).
 * Epic source strings for each code are listed in value_conversions.js CONSULTATION_DECISION rows.
 */
const CONSULTATION_DECISION_LABEL_BY_CODE = {
  '6': 'Consultation Completed',
  '4': 'Consultation Cancelled',
  '7': 'Consultation Delayed',
};

const CONSULTATION_DECISION_EPIC_TEXT_TO_LABEL = [
  [ 'consult completed', 'Consultation Completed' ],
  [ 'consultation completed', 'Consultation Completed' ],
  [ 'consult complete', 'Consultation Completed' ],
  [ 'consult cancelled', 'Consultation Cancelled' ],
  [ 'consultation cancelled', 'Consultation Cancelled' ],
  [ 'consult deferred', 'Consultation Deferred' ],
  [ 'consultation delayed', 'Consultation Delayed' ],
];

/**
 * Matches TGLN value_conversions CONSULTATION_CANCEL_REASON (TXP#274 — OATS sub-table for decision '4').
 * Epic source strings for each code are in value_conversions.js CONSULTATION_CANCEL_REASON rows.
 */
const CONSULTATION_CANCEL_REASON_LABEL_BY_CODE = {
  '7': 'Patient death related to organ failure',
  '8': 'Patient death not related to organ failure',
  '9': 'Patient relocated',
  '10': 'Duplicate consultation entry',
  '18': 'Inability to contact patient',
};

const CONSULTATION_CANCEL_REASON_EPIC_TEXT_TO_LABEL = [
  [ 'patient death related to organ failure', 'Patient death related to organ failure' ],
  [ 'patient death not related to organ failure', 'Patient death not related to organ failure' ],
  [ 'patient relocated', 'Patient relocated' ],
  [ 'duplicate consultation entry', 'Duplicate consultation entry' ],
  [ 'inability to contact patient', 'Inability to contact patient' ],
];

/**
 * Matches TGLN value_conversions CONSULTATION_DELAY_REASON (TXP#275 — OATS sub-table for decision '7').
 * Epic source strings for each code are in value_conversions.js CONSULTATION_DELAY_REASON rows.
 */
const CONSULTATION_DELAY_REASON_LABEL_BY_CODE = {
  '8': 'Abstinence from substance',
  '3': 'Change in medical status',
  '5': 'Emergency closures',
  '6': 'Physician/hospital staff unavailable',
  '7': 'Rescheduled due to higher priority recipient',
  '10': 'Transplant considerations (Paediatric only)',
  '11': 'VAD/Bridge to candidacy',
  '12': 'Work-up/consultation deferred',
  '9': 'Optimization therapy',
  '1': 'Recipient/Family chooses to defer/unavailable',
  '2': 'Inability to contact recipient',
  '4': 'Recipient missed consultation (no-show)',
};

const CONSULTATION_DELAY_REASON_EPIC_TEXT_TO_LABEL = [
  [ 'abstinence from substance', 'Abstinence from substance' ],
  [ 'change in medical status', 'Change in medical status' ],
  [ 'emergency closures', 'Emergency closures' ],
  [ 'physician/hospital staff unavailable', 'Physician/hospital staff unavailable' ],
  [ 'rescheduled due to higher priority recipient', 'Rescheduled due to higher priority recipient' ],
  [ 'rescheduled due to higher priority patient', 'Rescheduled due to higher priority patient' ],
  [ 'transplant considerations (paediatric only)', 'Transplant considerations (Paediatric only)' ],
  [ 'transplant considerations (paeds only)', 'Transplant considerations (paeds only)' ],
  [ 'vad/bridge to candidacy', 'VAD/Bridge to candidacy' ],
  [ 'work-up/consultation deferred', 'Work-up/consultation deferred' ],
  [ 'work up/consultation deferred', 'Work up/Consultation deferred' ],
  [ 'optimization therapy', 'Optimization therapy' ],
  [ 'recipient/family chooses to defer/unavailable', 'Recipient/Family chooses to defer/unavailable' ],
  [ 'inability to contact recipient', 'Inability to contact recipient' ],
  [ 'recipient missed consultation (no-show)', 'Recipient missed consultation (no-show)' ],
];

/**
 * Matches TGLN value_conversions ASSESSMENT_DECISION (TXP#287 — internal code → canonical OATS label).
 * Epic source strings for each code are the externalValue in each ASSESSMENT_DECISION row in value_conversions.js.
 * Code 4 has two equivalent Epic labels ('Recipient Cancelled' / 'Assessment Cancelled'); by-code display uses the first.
 */
const ASSESSMENT_DECISION_LABEL_BY_CODE = {
  '1': 'Recipient to be Listed',
  '2': 'Recipient not eligible for transplant',
  '3': 'Further Treatment/Testing Required',
  '4': 'Recipient Cancelled',
  '5': 'Recipient proceeding with living donor transplant',
};

const ASSESSMENT_DECISION_EPIC_TEXT_TO_LABEL = [
  [ 'recipient to be listed', 'Recipient to be Listed' ],
  [ 'recipient proceeding with living donor transplant', 'Recipient proceeding with living donor transplant' ],
  [ 'further treatment/testing required', 'Further Treatment/Testing Required' ],
  [ 'recipient not eligible for transplant', 'Recipient not eligible for transplant' ],
  [ 'recipient cancelled', 'Recipient Cancelled' ],
  [ 'assessment cancelled', 'Assessment Cancelled' ],
];

/**
 * Matches TGLN value_conversions ASSESSMENT_CANCEL_REASON (TXP#288 — OATS sub-table for assessment decision '4').
 * Epic source strings for each code are in value_conversions.js ASSESSMENT_CANCEL_REASON rows.
 */
const ASSESSMENT_CANCEL_REASON_LABEL_BY_CODE = {
  '7': 'Recipient death related to organ failure',
  '8': 'Recipient death not related to organ failure',
  '9': 'Recipient relocated',
  '10': 'Duplicate assessment entry',
  '18': 'Inability to contact recipient',
  '202': 'Recipient No longer Requires Transplant due to Recovery',
};

const ASSESSMENT_CANCEL_REASON_EPIC_TEXT_TO_LABEL = [
  [ 'recipient death related to organ failure', 'Recipient death related to organ failure' ],
  [ 'recipient death not related to organ failure', 'Recipient death not related to organ failure' ],
  [ 'recipient relocated', 'Recipient relocated' ],
  [ 'duplicate assessment entry', 'Duplicate assessment entry' ],
  [ 'inability to contact recipient', 'Inability to contact recipient' ],
  [ 'recipient no longer requires transplant due to recovery', 'Recipient No longer Requires Transplant due to Recovery' ],
];

/**
 * Matches TGLN value_conversions ASSESSMENT_NOT_ELIGIBLE_REASON (TXP#289 — OATS sub-table for assessment decision '2').
 * Epic source strings for each code are in value_conversions.js ASSESSMENT_NOT_ELIGIBLE_REASON rows.
 */
const ASSESSMENT_NOT_ELIGIBLE_REASON_LABEL_BY_CODE = {
  '3': 'Recipient does not meet listing criteria',
  '4': 'Recipient request',
  '5': 'Recipient referred to another transplant program',
  '6': 'Recipient too sick',
  '202': 'Recipient too well',
};

const ASSESSMENT_NOT_ELIGIBLE_REASON_EPIC_TEXT_TO_LABEL = [
  [ 'recipient does not meet listing criteria', 'Recipient does not meet listing criteria' ],
  [ 'recipient referred to another transplant program', 'Recipient referred to another transplant program' ],
  [ 'recipient referred to another program', 'Recipient referred to another program' ],
  [ 'recipient too sick', 'Recipient too sick' ],
  [ 'patient too sick', 'Patient too sick' ],
  [ 'recipient too well', 'Recipient too well' ],
  [ 'recipient request', 'Recipient request' ],
];

/**
 * Matches TGLN value_conversions CONTRAINDICATION_ABS (Kidney — internal code → canonical OATS label).
 */
const CONTRAINDICATION_ABS_LABEL_BY_CODE = {
  'A3-1': 'Co-morbidities',
  'A3-2': 'Consent',
  'A3-3': 'Post-Transplant Care',
  'A3-4': 'Psychosocial Considerations',
  'A3-5': 'Malignancy',
  'A3-6': 'Pulmonary Disease',
  'A3-7': 'Cardiac Disease',
  'A3-8': 'Peripheral Vascular Disease',
  'A3-9': 'Gastrointestinal Disease',
};

const CONTRAINDICATION_ABS_EPIC_TEXT_TO_LABEL = [
  [ 'co-morbidities', 'Co-morbidities' ],
  [ 'consent', 'Consent' ],
  [ 'post-transplant care', 'Post-Transplant Care' ],
  [ 'psychosocial considerations', 'Psychosocial Considerations' ],
  [ 'malignancy', 'Malignancy' ],
  [ 'pulmonary disease', 'Pulmonary Disease' ],
  [ 'cardiac disease', 'Cardiac Disease' ],
  [ 'peripheral vascular disease', 'Peripheral Vascular Disease' ],
  [ 'gastrointestinal disease', 'Gastrointestinal Disease' ],
];

/**
 * Matches TGLN value_conversions CONTRAINDICATION_ABS_LIVER (Liver — internal code → canonical OATS label).
 */
const CONTRAINDICATION_ABS_LIVER_LABEL_BY_CODE = {
  'A1-1': 'Co-morbidities',
  'A1-2': 'NUTRITIONAL STATE',
  'A1-3': 'INFECTIONS',
  'A1-4': 'MALIGNANCY',
  'A1-5': 'VASCULAR ABNORMALITIES',
  'A1-6': 'PSYCHOSOCIAL CONSIDERATIONS',
  'A1-7': 'DOES NOT MEET ALD CRITERIA',
  'P1-1': 'PAEDIATRIC - CO- MORBIDITIES',
  'P1-2': 'PAEDIATRIC - INFECTIONS',
  'P1-3': 'PAEDIATRIC - MALIGNANCY',
  'P1-4': 'PAEDIATRIC - VASCULAR ABNORMALITIES',
  'P1-5': 'PAEDIATRIC - PSYCHOSOCIAL CONSIDERATIONS',
  'P1-6': 'PAEDIATRIC - BLOOD TRANSFUSIONS',
};

const CONTRAINDICATION_ABS_LIVER_EPIC_TEXT_TO_LABEL = [
  [ 'co-morbidities', 'Co-morbidities' ],
  [ 'nutritional state', 'NUTRITIONAL STATE' ],
  [ 'infections', 'INFECTIONS' ],
  [ 'malignancy', 'MALIGNANCY' ],
  [ 'vascular abnormalities', 'VASCULAR ABNORMALITIES' ],
  [ 'psychosocial considerations', 'PSYCHOSOCIAL CONSIDERATIONS' ],
  [ 'does not meet ald criteria', 'DOES NOT MEET ALD CRITERIA' ],
  [ 'paediatric - co- morbidities', 'PAEDIATRIC - CO- MORBIDITIES' ],
  [ 'paediatric - infections', 'PAEDIATRIC - INFECTIONS' ],
  [ 'paediatric - malignancy', 'PAEDIATRIC - MALIGNANCY' ],
  [ 'paediatric - vascular abnormalities', 'PAEDIATRIC - VASCULAR ABNORMALITIES' ],
  [ 'paediatric - psychosocial considerations', 'PAEDIATRIC - PSYCHOSOCIAL CONSIDERATIONS' ],
  [ 'paediatric - blood transfusions', 'PAEDIATRIC - BLOOD TRANSFUSIONS' ],
];

/**
 * Matches TGLN value_conversions CONTRAINDICATION_ABS_HEART (Heart — internal code → canonical OATS label).
 */
const CONTRAINDICATION_ABS_HEART_LABEL_BY_CODE = {
  'A2-1': 'LIVER DISEASE',
  'A2-2': 'PULMONARY HYPERTENSION',
  'A2-3': 'MALIGNANCY',
  'A2-4': 'PULMONARY DISEASE',
  'A2-5': 'CONSENT',
  'A2-6': 'SYSTEMIC DISEASE',
  'A2-7': 'INFECTIONS',
  'A2-8': 'PYSCHOSOCIAL CONSIDERATIONS',
  'P2-1': 'PAEDIATRIC- CONSENT',
};

const CONTRAINDICATION_ABS_HEART_EPIC_TEXT_TO_LABEL = [
  [ 'liver disease', 'LIVER DISEASE' ],
  [ 'pulmonary hypertension', 'PULMONARY HYPERTENSION' ],
  [ 'malignancy', 'MALIGNANCY' ],
  [ 'pulmonary disease', 'PULMONARY DISEASE' ],
  [ 'consent', 'CONSENT' ],
  [ 'systemic disease', 'SYSTEMIC DISEASE' ],
  [ 'infections', 'INFECTIONS' ],
  [ 'pyschosocial considerations', 'PYSCHOSOCIAL CONSIDERATIONS' ],
  [ 'paediatric- consent', 'PAEDIATRIC- CONSENT' ],
];

/**
 * Matches TGLN value_conversions CONTRAINDICATION_ABS_LUNG (Lung — internal code → canonical OATS label).
 */
const CONTRAINDICATION_ABS_LUNG_LABEL_BY_CODE = {
  'A4-1': 'PSYCHOSOCIAL ISSUES',
  'A4-2': 'Bleeding Diathesis',
  'A4-3': 'OBESITY',
  'A4-4': 'INFECTIONS',
};

const CONTRAINDICATION_ABS_LUNG_EPIC_TEXT_TO_LABEL = [
  [ 'psychosocial issues', 'PSYCHOSOCIAL ISSUES' ],
  [ 'bleeding diathesis', 'Bleeding Diathesis' ],
  [ 'obesity', 'OBESITY' ],
  [ 'infections', 'INFECTIONS' ],
];

/**
 * Matches TGLN value_conversions CONTRAINDICATION_ABS_PANCREAS (Pancreas — internal code → canonical OATS label).
 */
const CONTRAINDICATION_ABS_PANCREAS_LABEL_BY_CODE = {
  'A6-1': 'Co-morbidities',
  'A6-2': 'Consent',
  'A3-3': 'Post-Transplant Care',
  'A6-4': 'Psychosocial Considerations',
  'A6-5': 'Malignancy',
  'A6-6': 'Pulmonary Disease',
  'A6-7': 'Cardiac Disease',
  'A6-8': 'Peripheral Vascular Disease',
  'A6-9': 'Gastrointestinal Disease',
};

const CONTRAINDICATION_ABS_PANCREAS_EPIC_TEXT_TO_LABEL = [
  [ 'co-morbidities', 'Co-morbidities' ],
  [ 'consent', 'Consent' ],
  [ 'post-transplant care', 'Post-Transplant Care' ],
  [ 'psychosocial considerations', 'Psychosocial Considerations' ],
  [ 'malignancy', 'Malignancy' ],
  [ 'pulmonary disease', 'Pulmonary Disease' ],
  [ 'cardiac disease', 'Cardiac Disease' ],
  [ 'peripheral vascular disease', 'Peripheral Vascular Disease' ],
  [ 'gastrointestinal disease', 'Gastrointestinal Disease' ],
];

/**
 * Matches TGLN value_conversions CONTRAINDICATION_ABS_INTESTINE (Intestine — internal code → canonical OATS label).
 */
const CONTRAINDICATION_ABS_INTESTINE_LABEL_BY_CODE = {
  'A7-1': 'Co-morbidities',
  'A7-2': 'Consent',
  'A7-3': 'Post-Transplant Care',
  'A7-4': 'Psychosocial Considerations',
  'A7-5': 'Malignancy',
  'A7-6': 'Pulmonary Disease',
  'A7-7': 'Cardiac Disease',
  'A7-8': 'Peripheral Vascular Disease',
  'P7-1': 'PAEDIATRIC - CORMORBIDITIES',
  'P7-2': 'PAEDIATRIC - CONSENT',
  'P7-3': 'PAEDIATRIC - POST-TRANSPLANT CARE',
  'P7-4': 'PAEDIATRIC - PSYCHOSOCIAL CONSIDERATIONS',
  'P7-5': 'PAEDIATRIC - MALIGNANCY',
  'P7-6': 'PAEDIATRIC - PULMONARY DISEASE',
  'P7-7': 'PAEDIATRIC - CADRIAC DISEASE',
  'P7-8': 'PAEDIATRIC - PERIPHERAL VASCULAR DISEASE',
};

const CONTRAINDICATION_ABS_INTESTINE_EPIC_TEXT_TO_LABEL = [
  [ 'co-morbidities', 'Co-morbidities' ],
  [ 'consent', 'Consent' ],
  [ 'post-transplant care', 'Post-Transplant Care' ],
  [ 'psychosocial considerations', 'Psychosocial Considerations' ],
  [ 'malignancy', 'Malignancy' ],
  [ 'pulmonary disease', 'Pulmonary Disease' ],
  [ 'cardiac disease', 'Cardiac Disease' ],
  [ 'peripheral vascular disease', 'Peripheral Vascular Disease' ],
  [ 'paediatric - cormorbidities', 'PAEDIATRIC - CORMORBIDITIES' ],
  [ 'paediatric - consent', 'PAEDIATRIC - CONSENT' ],
  [ 'paediatric - post-transplant care', 'PAEDIATRIC - POST-TRANSPLANT CARE' ],
  [ 'paediatric - psychosocial considerations', 'PAEDIATRIC - PSYCHOSOCIAL CONSIDERATIONS' ],
  [ 'paediatric - malignancy', 'PAEDIATRIC - MALIGNANCY' ],
  [ 'paediatric - pulmonary disease', 'PAEDIATRIC - PULMONARY DISEASE' ],
  [ 'paediatric - cadriac disease', 'PAEDIATRIC - CADRIAC DISEASE' ],
  [ 'paediatric - peripheral vascular disease', 'PAEDIATRIC - PERIPHERAL VASCULAR DISEASE' ],
];

const CONTRAINDICATION_ABS_OATS_MAPPINGS_BY_ORGAN = {
  Kidney: {
    labelByCode: CONTRAINDICATION_ABS_LABEL_BY_CODE,
    epicTextToLabel: CONTRAINDICATION_ABS_EPIC_TEXT_TO_LABEL,
  },
  Liver: {
    labelByCode: CONTRAINDICATION_ABS_LIVER_LABEL_BY_CODE,
    epicTextToLabel: CONTRAINDICATION_ABS_LIVER_EPIC_TEXT_TO_LABEL,
  },
  Heart: {
    labelByCode: CONTRAINDICATION_ABS_HEART_LABEL_BY_CODE,
    epicTextToLabel: CONTRAINDICATION_ABS_HEART_EPIC_TEXT_TO_LABEL,
  },
  Lung: {
    labelByCode: CONTRAINDICATION_ABS_LUNG_LABEL_BY_CODE,
    epicTextToLabel: CONTRAINDICATION_ABS_LUNG_EPIC_TEXT_TO_LABEL,
  },
  Pancreas: {
    labelByCode: CONTRAINDICATION_ABS_PANCREAS_LABEL_BY_CODE,
    epicTextToLabel: CONTRAINDICATION_ABS_PANCREAS_EPIC_TEXT_TO_LABEL,
  },
  Intestine: {
    labelByCode: CONTRAINDICATION_ABS_INTESTINE_LABEL_BY_CODE,
    epicTextToLabel: CONTRAINDICATION_ABS_INTESTINE_EPIC_TEXT_TO_LABEL,
  },
};

function resolveAbsoluteContraindicationOatsDisplay( rawValue, organ ) {
  if( rawValue == null || rawValue === '' ) {
    return;
  }
  const mapping = CONTRAINDICATION_ABS_OATS_MAPPINGS_BY_ORGAN[ organ ];
  const labelByCode = mapping?.labelByCode ?? null;
  const epicTextToLabel = mapping?.epicTextToLabel ?? null;
  if( !labelByCode ) {
    return Array.isArray( rawValue ) ? rawValue.join( ', ' ) : rawValue;
  }
  const items = Array.isArray( rawValue ) ? rawValue : [ rawValue ];
  const labels = items.map( ( item ) => {
    if( item == null || item === '' ) {
      return;
    }
    const key = String( item ).trim();
    const byCode = labelByCode[ key ];
    if( byCode ) {
      return byCode;
    }
    const normalized = key.toLowerCase();
    for( const [ epicLower, label ] of epicTextToLabel ) {
      if( normalized === epicLower ) {
        return label;
      }
    }
    return key;
  } ).filter( Boolean );
  return labels.length ? labels.join( ', ' ) : undefined;
}

/**
 * Matches TGLN value_conversions CONTRAINDICATION_REL (Kidney — internal code → canonical OATS label).
 */
const CONTRAINDICATION_REL_LABEL_BY_CODE = {
  'A3-1': 'Age and functional capacity',
  'A3-2': 'Cause of Kidney Disease',
  'A3-3': 'Psychosocial Considerations',
  'A3-4': 'Obesity',
  'A3-5': 'Systemic Diseases',
  'A3-6': 'Infections',
  'A3-7': 'Pulmonary Disease',
  'A3-8': 'Cardiac Disease',
  'A3-9': 'Cerebral Vascular Disease',
  'A3-10': 'Peripheral Vascular Disease',
  'A3-11': 'Gastrointestinal Disease',
  'A3-12': 'Liver Disease',
  'A3-13': 'Genitourinary Disease',
  'A3-14': 'Hematologic Disorders',
  'A3-15': 'Hyperparathyroidism',
  'P3-1': 'PAEDIATRIC- ACTIVE DISEASE',
  'P3-2': 'PAEDIATRIC- PROTEINURIA',
  'P3-3': 'PAEDIATRIC - WEIGHT AND HEIGHT',
};

const CONTRAINDICATION_REL_EPIC_TEXT_TO_LABEL = [
  [ 'age and functional capacity', 'Age and functional capacity' ],
  [ 'cause of kidney disease', 'Cause of Kidney Disease' ],
  [ 'psychosocial considerations', 'Psychosocial Considerations' ],
  [ 'obesity', 'Obesity' ],
  [ 'systemic diseases', 'Systemic Diseases' ],
  [ 'infections', 'Infections' ],
  [ 'pulmonary disease', 'Pulmonary Disease' ],
  [ 'cardiac disease', 'Cardiac Disease' ],
  [ 'cerebral vascular disease', 'Cerebral Vascular Disease' ],
  [ 'peripheral vascular disease', 'Peripheral Vascular Disease' ],
  [ 'gastrointestinal disease', 'Gastrointestinal Disease' ],
  [ 'liver disease', 'Liver Disease' ],
  [ 'genitourinary disease', 'Genitourinary Disease' ],
  [ 'hematologic disorders', 'Hematologic Disorders' ],
  [ 'hyperparathyroidism', 'Hyperparathyroidism' ],
  [ 'paediatric- active disease', 'PAEDIATRIC- ACTIVE DISEASE' ],
  [ 'paediatric- proteinuria', 'PAEDIATRIC- PROTEINURIA' ],
  [ 'paediatric - weight and height', 'PAEDIATRIC - WEIGHT AND HEIGHT' ],
];

/**
 * Matches TGLN value_conversions CONTRAINDICATION_REL_HEART (Heart — internal code → canonical OATS label).
 */
const CONTRAINDICATION_REL_HEART_LABEL_BY_CODE = {
  'A2-1': 'AGE',
  'A2-2': 'PULMONARY HYPERTENSION',
  'A2-3': 'OSTEOPOROSIS',
  'A2-4': 'OBESITY',
  'A2-5': 'DIABETES',
  'A2-6': 'GASTROINTENSTINAL DISEASE',
  'A2-7': 'CACHEXIA',
  'A2-8': 'FUNCTIONAL CAPACITY',
  'A2-9': 'PULMONARY INFARCTION',
  'A2-10': 'TECHNICAL ISSUES',
  'A2-11': 'PERIPHERAL AND CERBRAL VASCULAR DISEASE',
  'A2-12': 'RENAL DYSFUNCTION',
  'A2-13': 'AMYLOIDOSIS',
  'A2-14': 'CARDIAC DISEASE',
  'A2-15': 'SOCIAL SUPPORT',
  'A2-16': 'MALNUTRITION',
  'P2-1': 'PAEDIATRIC- DIABETES',
  'P2-2': 'PAEDIATRIC- OTHER DIAGNOSES',
  'P2-3': 'PAEDIATRIC - ANATOMIC',
  'P2-4': 'PAEDIATRIC - IMMUNIZATION',
  'P2-5': 'PAEDIATRIC- INFECTIONS',
  'P2-6': 'PAEDIATRIC - MALIGNANCY',
  'P2-7': 'PAEDIATRIC- MECHANICAL CIRCULATORY SUPPORT',
  'P2-8': 'PAEDIATRIC- MULTISYSTEM ORGAN FAILURE',
  'P2-9': 'PAEDIATRIC- PULMONARY HYPERTENSION',
  'P2-10': 'PAEDIATRIC- SYSTEMIC DISEASE',
  'P2-11': 'PAEDIATRIC- PYSCHOSOCIAL CONSIDERATIONS',
  'P2-12': 'PAEDIATRIC- SOCIAL SUPPORT',
};

const CONTRAINDICATION_REL_HEART_EPIC_TEXT_TO_LABEL = [
  [ 'age', 'AGE' ],
  [ 'pulmonary hypertension', 'PULMONARY HYPERTENSION' ],
  [ 'osteoporosis', 'OSTEOPOROSIS' ],
  [ 'obesity', 'OBESITY' ],
  [ 'diabetes', 'DIABETES' ],
  [ 'gastrointenstinal disease', 'GASTROINTENSTINAL DISEASE' ],
  [ 'cachexia', 'CACHEXIA' ],
  [ 'functional capacity', 'FUNCTIONAL CAPACITY' ],
  [ 'pulmonary infarction', 'PULMONARY INFARCTION' ],
  [ 'technical issues', 'TECHNICAL ISSUES' ],
  [ 'peripheral and cerbral vascular disease', 'PERIPHERAL AND CERBRAL VASCULAR DISEASE' ],
  [ 'renal dysfunction', 'RENAL DYSFUNCTION' ],
  [ 'amyloidosis', 'AMYLOIDOSIS' ],
  [ 'cardiac disease', 'CARDIAC DISEASE' ],
  [ 'social support', 'SOCIAL SUPPORT' ],
  [ 'malnutrition', 'MALNUTRITION' ],
  [ 'paediatric- diabetes', 'PAEDIATRIC- DIABETES' ],
  [ 'paediatric- other diagnoses', 'PAEDIATRIC- OTHER DIAGNOSES' ],
  [ 'paediatric - anatomic', 'PAEDIATRIC - ANATOMIC' ],
  [ 'paediatric - immunization', 'PAEDIATRIC - IMMUNIZATION' ],
  [ 'paediatric- infections', 'PAEDIATRIC- INFECTIONS' ],
  [ 'paediatric - malignancy', 'PAEDIATRIC - MALIGNANCY' ],
  [ 'paediatric- mechanical circulatory support', 'PAEDIATRIC- MECHANICAL CIRCULATORY SUPPORT' ],
  [ 'paediatric- multisystem organ failure', 'PAEDIATRIC- MULTISYSTEM ORGAN FAILURE' ],
  [ 'paediatric- pulmonary hypertension', 'PAEDIATRIC- PULMONARY HYPERTENSION' ],
  [ 'paediatric- systemic disease', 'PAEDIATRIC- SYSTEMIC DISEASE' ],
  [ 'paediatric- pyschosocial considerations', 'PAEDIATRIC- PYSCHOSOCIAL CONSIDERATIONS' ],
  [ 'paediatric- social support', 'PAEDIATRIC- SOCIAL SUPPORT' ],
];

/**
 * Matches TGLN value_conversions CONTRAINDICATION_REL_LUNG (Lung — internal code → canonical OATS label).
 */
const CONTRAINDICATION_REL_LUNG_LABEL_BY_CODE = {
  'A4-1': 'AGE',
  'A4-2': 'MEDICAL STABILITY',
  'A4-3': 'FUNCTIONAL STATUS',
  'A4-4': 'INFECTIONS',
  'A4-5': 'OBESITY',
  'A4-6': 'OSTEOPOROSIS',
  'A4-7': 'MECHANICAL VENTILATION',
  'A4-8': 'DISEASE',
  'A4-9': 'MALIGNANCY',
  'A4-10': 'DEFORMITY',
  'A4-11': 'MALNUTRITION',
  'A4-12': 'CHEST SURGERY',
};

const CONTRAINDICATION_REL_LUNG_EPIC_TEXT_TO_LABEL = [
  [ 'age', 'AGE' ],
  [ 'medical stability', 'MEDICAL STABILITY' ],
  [ 'functional status', 'FUNCTIONAL STATUS' ],
  [ 'infections', 'INFECTIONS' ],
  [ 'obesity', 'OBESITY' ],
  [ 'osteoporosis', 'OSTEOPOROSIS' ],
  [ 'mechanical ventilation', 'MECHANICAL VENTILATION' ],
  [ 'disease', 'DISEASE' ],
  [ 'malignancy', 'MALIGNANCY' ],
  [ 'deformity', 'DEFORMITY' ],
  [ 'malnutrition', 'MALNUTRITION' ],
  [ 'chest surgery', 'CHEST SURGERY' ],
];

/**
 * Matches TGLN value_conversions CONTRAINDICATION_REL_PANCREAS (Pancreas — internal code → canonical OATS label).
 */
const CONTRAINDICATION_REL_PANCREAS_LABEL_BY_CODE = {
  'A6-1': 'AGE AND FUNCTION CAPACITY',
  'A6-2': 'RENAL FUNCTION',
  'A6-3': 'PSYCHOSOCIAL CONSIDERATIONS',
  'A6-4': 'OBESITY',
  'A6-5': 'SYSTEMIC DISEASES',
  'A6-6': 'INFECTIONS',
  'A6-7': 'PULMONARY DISEASE',
  'A6-8': 'CARDIAC DISEASE',
  'A6-9': 'CEREBRAL VASCULAR DISEASE',
  'A6-10': 'PERIPHERAL VASCULAR DISEASE',
  'A6-11': 'GASTROINTESTINAL DISEASE',
  'A6-12': 'LIVER DISEASE',
  'A6-13': 'GENITOURINARY DISEASE',
  'A6-14': 'HEMATOLOGIC DISORDERS',
  'A6-15': 'HYPERPARATHYROIDISM',
};

const CONTRAINDICATION_REL_PANCREAS_EPIC_TEXT_TO_LABEL = [
  [ 'age and function capacity', 'AGE AND FUNCTION CAPACITY' ],
  [ 'renal function', 'RENAL FUNCTION' ],
  [ 'psychosocial considerations', 'PSYCHOSOCIAL CONSIDERATIONS' ],
  [ 'obesity', 'OBESITY' ],
  [ 'systemic diseases', 'SYSTEMIC DISEASES' ],
  [ 'infections', 'INFECTIONS' ],
  [ 'pulmonary disease', 'PULMONARY DISEASE' ],
  [ 'cardiac disease', 'CARDIAC DISEASE' ],
  [ 'cerebral vascular disease', 'CEREBRAL VASCULAR DISEASE' ],
  [ 'peripheral vascular disease', 'PERIPHERAL VASCULAR DISEASE' ],
  [ 'gastrointestinal disease', 'GASTROINTESTINAL DISEASE' ],
  [ 'liver disease', 'LIVER DISEASE' ],
  [ 'genitourinary disease', 'GENITOURINARY DISEASE' ],
  [ 'hematologic disorders', 'HEMATOLOGIC DISORDERS' ],
  [ 'hyperparathyroidism', 'HYPERPARATHYROIDISM' ],
];

const CONTRAINDICATION_REL_OATS_MAPPINGS_BY_ORGAN = {
  Kidney: {
    labelByCode: CONTRAINDICATION_REL_LABEL_BY_CODE,
    epicTextToLabel: CONTRAINDICATION_REL_EPIC_TEXT_TO_LABEL,
  },
  Heart: {
    labelByCode: CONTRAINDICATION_REL_HEART_LABEL_BY_CODE,
    epicTextToLabel: CONTRAINDICATION_REL_HEART_EPIC_TEXT_TO_LABEL,
  },
  Lung: {
    labelByCode: CONTRAINDICATION_REL_LUNG_LABEL_BY_CODE,
    epicTextToLabel: CONTRAINDICATION_REL_LUNG_EPIC_TEXT_TO_LABEL,
  },
  Pancreas: {
    labelByCode: CONTRAINDICATION_REL_PANCREAS_LABEL_BY_CODE,
    epicTextToLabel: CONTRAINDICATION_REL_PANCREAS_EPIC_TEXT_TO_LABEL,
  },
};

function resolveRelativeContraindicationOatsDisplay( rawValue, organ ) {
  if( rawValue == null || rawValue === '' ) {
    return;
  }
  const mapping = CONTRAINDICATION_REL_OATS_MAPPINGS_BY_ORGAN[ organ ];
  const labelByCode = mapping?.labelByCode ?? null;
  const epicTextToLabel = mapping?.epicTextToLabel ?? null;
  if( !labelByCode ) {
    return Array.isArray( rawValue ) ? rawValue.join( ', ' ) : rawValue;
  }
  const items = Array.isArray( rawValue ) ? rawValue : [ rawValue ];
  const labels = items.map( ( item ) => {
    if( item == null || item === '' ) {
      return;
    }
    const key = String( item ).trim();
    const byCode = labelByCode[ key ];
    if( byCode ) {
      return byCode;
    }
    const normalized = key.toLowerCase();
    for( const [ epicLower, label ] of epicTextToLabel ) {
      if( normalized === epicLower ) {
        return label;
      }
    }
    return key;
  } ).filter( Boolean );
  return labels.length ? labels.join( ', ' ) : undefined;
}

/**
 * Matches TGLN value_conversions PROVINCE (UHN#3983 / REFDTL_ORG_STATE — Epic label → OATS province code).
 * Order matches backend rows; first case-insensitive Epic match wins (same as applyConversion).
 */
const PROVINCE_EPIC_TO_CODE_ROWS = [
  [ 'AB', 'ALBERTA' ],
  [ 'BC', 'BRITISH COLUMBIA' ],
  [ 'MB', 'MANITOBA' ],
  [ 'NB', 'NEW BRUNSWICK' ],
  [ 'NL', 'NEWFOUNDLAND and LABRADOR' ],
  [ 'NS', 'NOVA SCOTIA' ],
  [ 'NT', 'NORTHWEST TERRITORIES' ],
  [ 'NU', 'NUNAVUT' ],
  [ 'ON', 'ONTARIO' ],
  [ 'PE', 'PRINCE EDWARD ISLAND' ],
  [ 'QC', 'QUEBEC' ],
  [ 'SK', 'SASKATCHEWAN' ],
  [ 'YT', 'YUKON' ],
  [ 'ZZ', 'Unknown Canadian Province' ],
  [ 'ZZ', 'USA PROVINCE' ],
  [ 'AL', 'Alabama' ],
  [ 'AK', 'Alaska' ],
  [ 'AZ', 'Arizona' ],
  [ 'AR', 'Arkansas' ],
  [ 'CA', 'California' ],
  [ 'CO', 'Colorado' ],
  [ 'CT', 'Connecticut' ],
  [ 'DE', 'Delaware' ],
  [ 'DC', 'District of Columbia' ],
  [ 'FL', 'Florida' ],
  [ 'GA', 'Georgia' ],
  [ 'HI', 'Hawaii' ],
  [ 'ID', 'Idaho' ],
  [ 'IL', 'Illinois' ],
  [ 'IN', 'Indiana' ],
  [ 'IA', 'Iowa' ],
  [ 'KS', 'Kansas' ],
  [ 'KY', 'Kentucky' ],
  [ 'LA', 'Louisiana' ],
  [ 'ME', 'Maine' ],
  [ 'MD', 'Maryland' ],
  [ 'MA', 'Massachusetts' ],
  [ 'MI', 'Michigan' ],
  [ 'MN', 'Minnesota' ],
  [ 'MS', 'Mississippi' ],
  [ 'MO', 'Missouri' ],
  [ 'MT', 'Montana' ],
  [ 'NE', 'Nebraska' ],
  [ 'NV', 'Nevada' ],
  [ 'NH', 'New Hampshire' ],
  [ 'NJ', 'New Jersey' ],
  [ 'NM', 'New Mexico' ],
  [ 'NY', 'New York' ],
  [ 'NC', 'North Carolina' ],
  [ 'ND', 'North Dakota' ],
  [ 'OH', 'Ohio' ],
  [ 'OK', 'Oklahoma' ],
  [ 'OR', 'Oregon' ],
  [ 'PA', 'Pennsylvania' ],
  [ 'RI', 'Rhode Island' ],
  [ 'SC', 'South Carolina' ],
  [ 'SD', 'South Dakota' ],
  [ 'TN', 'Tennessee' ],
  [ 'TX', 'Texas' ],
  [ 'UT', 'Utah' ],
  [ 'VT', 'Vermont' ],
  [ 'VA', 'Virginia' ],
  [ 'WA', 'Washington' ],
  [ 'WV', 'West Virginia' ],
  [ 'WI', 'Wisconsin' ],
  [ 'WY', 'Wyoming' ],
  [ 'UN', 'Unknown' ],
  [ 'ZZ', 'OTHER' ],
];

/** OATS COUNTRY — mirrors backend ValueConversions.COUNTRY (value_conversions.js) */
const COUNTRY_EPIC_TO_CODE_ROWS = [
  [ 'CAN', 'CA' ],
  [ 'CAN', 'Canada' ],
  [ 'USA', 'US' ],
  [ 'USA', 'USA' ],
  [ 'USA', 'United States of America' ],
];

function mapCountryEpicValueToInternalCode( raw ) {
  if ( raw === '' ) {
    return '';
  }
  if ( raw == null ) {
    return 'XX';
  }
  const trimmed = String( raw ).trim();
  if ( trimmed === '' ) {
    return '';
  }
  const tUpper = trimmed.toUpperCase();
  for ( const [ code, epic ] of COUNTRY_EPIC_TO_CODE_ROWS ) {
    if ( epic && String( epic ).trim().toUpperCase() === tUpper ) {
      return code;
    }
  }
  for ( const [ code ] of COUNTRY_EPIC_TO_CODE_ROWS ) {
    if ( code.toUpperCase() === tUpper ) {
      return code;
    }
  }
  return 'XX';
}

function mapProvinceEpicValueToInternalCode( raw ) {
  if ( raw == null || raw === '' ) {
    return;
  }
  const trimmed = String( raw ).trim();
  const tUpper = trimmed.toUpperCase();
  for ( const [ code, epic ] of PROVINCE_EPIC_TO_CODE_ROWS ) {
    if ( epic && String( epic ).trim().toUpperCase() === tUpper ) {
      return code;
    }
  }
  for ( const [ code ] of PROVINCE_EPIC_TO_CODE_ROWS ) {
    if ( code.toUpperCase() === tUpper ) {
      return code;
    }
  }
  return trimmed;
}

export default {
  name: "ReferralConsultationSectionOATSDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientType:{
      type: String,
      default: null
    },
    patientBundle: {
      type: Object,
      default: null,
    }
    ,
    patientBundleOATS: {
      type: Object,
      default: null,
    },
    organ: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      tglnId : this.getTglnId( this.patient ),
      oatstglnId: this.getOATSTglnID( this.patientBundleOATS ),
      oatsMiddleName: this.getOATSMiddleName( this.patientBundleOATS ),
      birthDate: this.patient.birthDate,
      oatsBirthDate: this.getOATSBirthDate( this.patientBundleOATS ),
      gender: this.patient.gender,
      oatsSex: this.getOATSSex( this.patientBundleOATS ),
      isGenderDifferent: this.getIsGenderDifferent( this.patientBundle ),
      oatsIsGenderDifferent: this.getOATSIsGenderDifferent( this.patientBundleOATS ),
      oatsGender: this.getOATSGender( this.patientBundleOATS ),
      oatsGenderOther: this.getOATSGenderOther( this.patientBundleOATS ),
      genderDifferent: this.getGenderDifferent( this.patient ),
      genderOther: this.getGenderOther( this.patientBundle ),
      age: this.calculateAge( this.patient.birthDate ),
      oatsAge: this.getOATSAge( this.patientBundleOATS ),
      mobile: this.getMobile( this.patient ),
      homeNumber: this.getHomeNumber( this.patient ),
      oatsHomeNumber: this.getOATSHomeNumber( this.patientBundleOATS ),
      email: this.getEmail( this.patient ),
      oatsEmail: this.getOATSEmail( this.patientBundleOATS ),
      pager: this.getPager( this.patient ),
      oatsPager: this.getOATSPager( this.patientBundleOATS ),
      ethnicity: this.getEthnicity( this.patientBundle ),
      oatsEthnicity: this.getOATSEthnicity( this.patientBundleOATS ),
      ethnicityOther: this.getEthnicityOther( this.patientBundle ),
      oatsEthnicityOther: this.getOATSEthnicityOther( this.patientBundleOATS ),
      insuranceType: this.getInsuranceType( this.patientBundle ),
      insuranceNumber: this.getInsuranceNumber( this.patientBundle ),
      insuranceProvince: this.getInsuranceProvince( this.patientBundle ),
      className: this.getClassName( this.patientBundle ),
      bloodType: this.getBloodType( this.patientBundle ),
      rhFactor: this.getRHFactor( this.patientBundle ),
      oatsRHFactor: this.getOATSRHFactor( this.patientBundleOATS ),
      oatsBloodType: this.getOATSBloodType( this.patientBundleOATS ),
      bloodTypeVerified: this.getBloodTypeVerified( this.patientBundle ),
      oatsBloodTypeVerified: this.getOATSBloodTypeVerified( this.patientBundleOATS ),
      //cPRA: this.getCPRA( this.patientBundle ),
      transplantProgram: this.getTransplantProgram( this.patientBundle ),
      oatsTransplantProgram: this.getOATSTransplantProgram( this.patientBundleOATS, this.organ ),
      recipientCoordinator: this.getRecipientCoordinator( this.patientBundle ),
      oatsrecipientCoordinator: this.getOATSRecipientCoordinator( this.patientBundleOATS, this.organ ),
      referralReceivedDate: this.getReferralReceivedDate( this.patientBundle ),
      oatsReferralReceivedDate: this.getReferralReceivedDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      referralDecisionDate: this.getReferralDecisionDate( this.patientBundle ),
      oatsreferralDecisionDate: this.getReferralDecisionDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      referralDecision: this.getReferralDecision( this.patientBundle, this.organ ),
      oatsreferralDecision: this.getReferralDecisionOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      referralDecisionReason: this.getReferralDecisionReason( this.patientBundle, this.organ ),
      oatsReferralDecisionReason: this.getReferralDecisionReasonOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      referralDecisionComments: this.getReferralDecisionComments( this.patientBundle ),
      oatsreferralDecisionComments: this.getReferralDecisionCommentsOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      primaryDiagnosis: this.getPrimaryDiagnosis( this.patientBundle, this.organ ),
      secondaryDiagnosis: this.getSecondaryDiagnosis( this.patientBundle, this.organ ),
      oatsSecondaryDiagnosis: this.getSecondaryDiagnosisOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      oatsPrimaryDiagnosisDate: this.getPrimaryDiagnosisDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      oatsPrimaryDiagnosis: this.getPrimaryDiagnosisOATS( this.patientBundleOATS, this.organ ),
      primaryDiagnosisDate: this.getPrimaryDiagnosisDate( this.patientBundle, this.organ ),
      referringOrganizationName: this.getReferringOrganizationName( this.patientBundle ),
      oatsReferringOrganizationName: this.getReferringOrganizationNameOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      referringOrganizationType: this.getReferringOrganizationType( this.patientBundle ),
      oatsReferringOrganizationType: this.getReferringOrganizationTypeOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      otherOrganizationType: this.getOtherOrganizationType( this.patientBundle ),
      referringHealthCareProfessionalType: this.getReferringHealthCareProfessionalType( this.patientBundle ),
      oatsReferringHealthCareProfessionalType: this.getReferringHealthCareProfessionalTypeOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      consultationDate: this.getConsultationDate( this.patientBundle, this.organ ),
      oatsConsultationDate: this.getConsultationDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      consultationDecision: this.getConsultationDecision( this.patientBundle, this.organ ),
      oatsConsultationDecision: this.getConsultationDecisionOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      reasonCancelled: this.getReasonCancelled( this.patientBundle, this.organ ),
      oatsReasonCancelled: this.getReasonCancelledOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      consultationCancelledDate: this.getConsultationCancelledDate( this.patientBundle, this.organ ),
      reasonDelayed: this.getReasonDelayed( this.patientBundle, this.organ ),
      oatsReasonDelayed: this.getReasonDelayedOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      primaryTransplantPhysician: this.getPrimaryTransplantPhysician( this.patientBundle ),
      oatsPrimaryTransplantPhysician: this.getPrimaryTransplantPhysicianOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      consultationDelayStartDate: this.getConsultationDelayStartDate( this.patientBundle, this.organ ),
      oatsConsultationDelayStartDate: this.getConsultationDelayStartDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      consultationDelayEndDate: this.getConsultationDelayEndDate( this.patientBundle, this.organ ),
      oatsConsultationDelayEndDate: this.getConsultationDelayEndDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      consultationComments: this.getConsultationComments( this.patientBundle, this.organ ),
      oatsConsultationComments: this.getConsultationCommentsOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      assessmentDate: this.getAssessmentDate( this.patientBundle, this.organ ),
      oatsAssessmentDate: this.getAssessmentDateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      assessmentDecision: this.getAssessmenDecision( this.patientBundle, this.organ ),
      oatsAssessmentDecision: this.getAssessmenDecisionOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      reasonAssessmentCancelled: this.getReasonAssessmentCancelled( this.patientBundle, this.organ ),
      oatsReasonAssessmentCancelled: this.getReasonAssessmentCancelledOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      reasonRecipientNotEligible: this.getReasonRecipientNotEligible( this.patientBundle, this.organ ),
      oatsReasonRecipientNotEligible: this.getReasonRecipientNotEligibleOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      reasonFurtherTreatment: this.getReasonFurtherTreatment( this.patientBundle, this.organ ),
      oatsReasonFurtherTreatment: this.getReasonFurtherTreatmentOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      other: this.getOther( this.patientBundle, this.organ ),
      oatsOther: this.getOtherOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      absoluteContraindication: this.getAbsoluteContraindication( this.patientBundle, this.organ ),
      oatsAbsoluteContraindication: this.getAbsoluteContraindicationOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      relativeContraindication: this.getRelativeContraindication( this.patientBundle ),
      oatsRelativeContraindication: this.getRelativeContraindicationOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      comments: this.getComments( this.patientBundle ),
      oatsComments: this.getCommentsOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      careTeamID: this.getCareTeamID( this.patientBundle ),
      firstName: this.getFirstName( this.patientBundle ),
      oatsFirstName: this.getFirstNameOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      lastName: this.getLastName( this.patientBundle ),
      oatsLastName: this.getLastNameOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      address: this.getAddress( this.patientBundle ),
      oatsAddress: this.getAddressOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      city: this.getCity( this.patientBundle ),
      oatsCity: this.getCityOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      country: this.getCountry( this.patientBundle ),
      oatsCountry: this.getCountryOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      postalCode: this.getPostalCode( this.patientBundle ),
      oatsPostalCode: this.getPostalCodeOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
      state: this.getState( this.patientBundle ),
      oatsState: this.getStateOATS( this.patientBundleOATS, this.organ, this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    isDifferent( a, b ) {
      return String( a ?? '' ).trim()?.toLowerCase() !== String( b ?? '' ).trim()?.toLowerCase();
  },
    getEpisodePhase( patientBundle ) {
      if ( !patientBundle?.entries ) {
        return;
      }
      let episodeOfCares = patientBundle.entries.filter( ( n ) => (
        _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' 
      ) );
      if ( !( episodeOfCares?.[0]?.[0] ) ) {
        return;
      }
      const episodeOfCare = episodeOfCares[0].filter( ( n ) => ( _.get( n, 'resource.id' ) === patientBundle.episode_id ) );
      if ( !( episodeOfCare ) ) {
        return;
      }
      const extensions = episodeOfCare?.[ 0 ]?.resource?.extension;
      if ( !extensions ) {
        return;
      }
      for ( const item of extensions ) {
        if ( item.url?.includes( 'transplant-phase-status' ) && item.extension?.length ) {
          const phaseExt = item.extension.filter( ( ext ) => ext.url === 'phase' );
          if ( phaseExt?.[0] ) {
            return _.get( phaseExt[0], 'valueCodeableConcept.coding[0].code' );
          }
        }
      }
    },
    calculateAge( birthDate ) {
      let age = Math.floor( ( new Date() - new Date( birthDate ) ) / 31536000000 );
      return age.toString();
    },
    getTglnId( patient ) {
      let identifier_type="TGLNRecipient"; // By default, it was already recipient, so keeping it as that for now.
      switch( this.patientType ){
        case PATIENT_TYPES.DONOR.name:
          identifier_type = "TGLNDonor";
          break;
        case PATIENT_TYPES.RECIPIENT.name:
          identifier_type = "TGLNRecipient";
          break;
      }
      let tglnId = patient.identifier.filter( ( n ) => ( n.use === 'usual' && n.type?.text === identifier_type ) ) ;
      return tglnId[0]?.value ? tglnId[0]?.value : '--' ;
    },
    getOATSTglnID( patientBundleOATS ) {
      return patientBundleOATS?.client_id;
    },
    getOATSMiddleName( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.middle_name;
    },
    getOATSBirthDate( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.birth?.date;
    },
    getOATSSex( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.sex;
    },
    getOATSIsGenderDifferent( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.gender_sex_different;
    },
    getOATSGender( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.gender;
    },
    getOATSGenderOther( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.gender;
    },
    getOATSAge( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.age;
    },
    getOATSHomeNumber( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.contact_details?.phone_primary;
    },
    getOATSEmail( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.contact_details?.email;
    },
    getOATSPager( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.contact_details?.phone_pager;
    },
    getOATSEthnicity( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.ethnicity_code;
    },
    getOATSEthnicityOther( patientBundleOATS ) {
      return patientBundleOATS?.patient_profile?.ethnicity_other;
    },
    getOATSRHFactor( patientBundleOATS ) {
      return patientBundleOATS?.diagnostics?.blood?.rh_indicator;
    },
    getOATSBloodType( patientBundleOATS ) {
      return patientBundleOATS?.diagnostics?.blood?.type;
    },
    getOATSBloodTypeVerified( patientBundleOATS ) {
      return patientBundleOATS?.diagnostics?.blood?.type_verified;
    },
    getMobile( patient ) {
      let mobile = patient.telecom?.filter( ( n ) => ( n.use === 'mobile' ) ) ;
      if( mobile ) {
        const value = String( _.get( mobile[ 0 ], 'value', '' ) );
        return value.replace( /^\s*(?:\+1)\s*[-.]?\s*/, '' );
      } 
      return ' ';
      // return _.get( mobile[ 0 ], 'value', 'r' ); 
    },
    getHomeNumber( patient ) {
      let home = patient.telecom?.filter( ( n ) => ( n.use === 'home' ) ) ;
      if( home && home[0] && home[0].value ) {
        return home[0].value;
      }   
    },
    getEmail( patient ) {
      let email = patient.telecom?.filter( ( n ) => ( n.system === 'email' ) ) ;
      if( email && email[0] && email[0].value ) {
        return email[0].value;
      }   
    },
    getPager( patient ) {
      let pager = patient.telecom?.filter( ( n ) => ( n.system === 'pager' ) ) ;
      if( pager && pager[0] && pager[0].value ) {
        return pager[0].value;
      }   
    },
    getEthnicity( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let ethnicity = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3813' ) ) ;
      if( ethnicity && ethnicity[ 0 ] ) {
        return _.get( ethnicity[0], 'resource.component[0].valueString', '' );
      } 
      }
    },
    getEthnicityOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let ethnicity = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3822' ) ) ;
      if( ethnicity && ethnicity[ 0 ] ) {
        return _.get( ethnicity[0], 'resource.component[0].valueString', '' );
      } 
      }
    },
    getIsGenderDifferent( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let genderDifferent = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#320' ) ) ;
      if( genderDifferent && genderDifferent[ 0 ] ) {
        return _.get( genderDifferent[ 0 ], 'resource.component[0].valueBoolean', 'Unchecked' ) === true ? 'checked' : 'unchecked';
      } 
      return 'unchecked';
      }
    },
    getGenderDifferent( patient ) {
      let patientExtension = patient.extension ;
      if( patientExtension && patientExtension[ 0 ] ) {
        for( let item of patientExtension ) {
             if( item.url?.includes( "patient-genderIdentity" ) ) {
              return _.get( item, 'valueCodeableConcept.coding[0].code', '' );
             }
        
      }
      }
    },
    getGenderOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let genderOther = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#321' ) ) ;
      if( genderOther && genderOther[ 0 ] ) {
        return _.get( genderOther[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getInsuranceType( patientBundle ) {
      let coverages = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Coverage' && _.get( n[0], 'resource.status' ) === 'active' ) );
      if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
        return _.get( coverages[ 0 ][ 0 ], 'resource.contained[0].name' );
      }
    },
    getInsuranceNumber( patientBundle ) {
      let coverages = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Coverage' && _.get( n[0], 'resource.status' ) === 'active' ) );
      if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
        return _.get( coverages[ 0 ][ 0 ], 'resource.subscriberId' );
     }
    },
    getInsuranceProvince( patientBundle ) {
      let coverages = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Coverage' && _.get( n[0], 'resource.status' ) === 'active' ) );
      if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
        return _.get( coverages[ 0 ][ 0 ], 'resource.contained[0].contact[0].address.state' );
     }
    },
    getClassName( patientBundle ) {
      let coverages = patientBundle.entries.filter( ( n ) => ( n[ 0 ].resource?.resourceType === 'Coverage' && n[ 0 ].resource?.status === 'active' ) );
      if( coverages && coverages[ 0 ] && coverages [ 0 ][ 0 ] ) {
        return coverages[ 0 ][ 0 ].resource?.class[ 0 ]?.name;
      }
    },
    getBloodType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let bloodType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3569' ) ) ;
      if( bloodType && bloodType[ 0 ] ) {
        return _.get( bloodType[0], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getRHFactor( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let rhFactor = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3570' ) ) ;
      if( rhFactor && rhFactor[ 0 ] ) {
        return _.get( rhFactor[0], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getBloodTypeVerified( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let bloodTypeVerified = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3552' ) ) ;
      if( bloodTypeVerified && bloodTypeVerified[ 0 ] ) {
        return _.get( bloodTypeVerified[0], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked' ; 
      } 
      }
    },
    getTransplantProgram( patientBundle ) {
      let episodeOfCare = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' ) );
      if( episodeOfCare && episodeOfCare[ 0 ] && episodeOfCare[ 0 ][ 0 ] ) {
        for( let item of episodeOfCare[ 0 ][ 0 ]?.resource?.extension ) {
             if( item.url?.includes( "transplant-center" ) ) {
              return item.valueString;
             }
        
      }
      }
    },
    getOATSTransplantProgram( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        const transplantHospitalId = journey[ 0 ].transplant_program?.transplant_hospital_id;
        return transplantHospitalId === '635c84467575ec2a0b026422' ? 'Toronto General Hospital' : 'no match found';
      }
      return 'no match found';
    },
    getRecipientCoordinator( patientBundle ) {
      let episodeOfCare = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' ) );
      if( episodeOfCare && episodeOfCare[ 0 ] && episodeOfCare[ 0 ][ 0 ] ) {
        for( let item of episodeOfCare[ 0 ][ 0 ]?.resource?.extension ) {
             if( item.url?.includes( "transplant-organ-coordinator" ) ) {
              let coordinator = item.extension.filter( ( n ) => ( n.url === 'coordinator' ) );
              if( coordinator && coordinator[ 0 ] )
              return _.get( coordinator[0], 'valueReference.display' )
             }
        
      }
      }
    },
    getOATSRecipientCoordinator( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].transplant_program?.transplant_coordinator_id;
      }
    },
    getCareTeamID( patientBundle ) {
      let episodeOfCare = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' ) );
      if( episodeOfCare && episodeOfCare[ 0 ] && episodeOfCare[ 0 ][ 0 ] ) {
       return _.get( episodeOfCare[ 0 ][ 0 ], 'resource.team[0].reference' ) .replace( 'CareTeam/', '' );
      }
    },
    getReferralReceivedDate( patientBundle ) {
      let episodeOfCares = patientBundle.entries.filter( ( n ) => (
        _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' 
      ) );
      if ( !( episodeOfCares && episodeOfCares[ 0 ] ) ) {
        return;
      }
      const episodeOfCare = episodeOfCares[0].filter( ( n ) => ( _.get( n, 'resource.id' ) === patientBundle.episode_id ) );
      if ( !( episodeOfCare && episodeOfCare[ 0 ] ) ) {
        return;
      }
      if( episodeOfCare && episodeOfCare[ 0 ] ) {
        for( let item of episodeOfCare[ 0 ]?.resource?.extension ) {
             if( item.url?.includes( "transplant-event-referral-date" ) ) {
              return item.valueDate;
             }
      }
      }
    },
    getReferralDecisionDate( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let referralDecisionDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4113' : 'UHN#3985' ) 
        && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referralDecisionDate && referralDecisionDate[ 0 ] ) {
        return _.get( referralDecisionDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getReferralDecision( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let referralDecision = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4112' : 'UHN#3973' ) 
         && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referralDecision && referralDecision[ 0 ] ) {
        return _.get( referralDecision[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReferralDecisionReason( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let referralDecisionReason = observation[ 0 ].filter( ( n ) => ( ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4114' : 'UHN#3975' )
        || _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3976' ) && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
        if( referralDecisionReason && referralDecisionReason[ 0 ] ) {
        return _.get( referralDecisionReason[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReferralDecisionComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let referralDecisionComments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#323' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referralDecisionComments && referralDecisionComments[ 0 ] ) {
        return _.get( referralDecisionComments[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getPrimaryDiagnosis( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let primaryDiagnosis = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4109' : 'UHN#3971' ) &&
         _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( primaryDiagnosis && primaryDiagnosis[ 0 ]?.resource?.code?.text ) {
        return _.get( primaryDiagnosis[0], 'resource.component[0].valueCodeableConcept.text' );
      } 
      }
    },
    getSecondaryDiagnosis( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let primaryDiagnosis = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4111' : 'UHN#3984' ) && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( primaryDiagnosis && primaryDiagnosis[ 0 ]?.resource?.code?.text ) {
        return _.get( primaryDiagnosis[0], 'resource.component[0].valueCodeableConcept.text' );
      } 
      }
    },
    getPrimaryDiagnosisDate( patientBundle ) {
      
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let primaryDiagnosis = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#338' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( primaryDiagnosis && primaryDiagnosis[ 0 ] ) {
        return _.get( primaryDiagnosis[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getReferringOrganizationName( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let referringOrganizationName = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3555' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referringOrganizationName && referringOrganizationName[ 0 ] ) {
        return _.get( referringOrganizationName[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReferringOrganizationType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let referringOrganizationName = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3556' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referringOrganizationName && referringOrganizationName[ 0 ] ) {
        return _.get( referringOrganizationName[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getOtherOrganizationType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let otherOrganizationType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#278' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( otherOrganizationType && otherOrganizationType[ 0 ] ) {
        return _.get( otherOrganizationType[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReferringHealthCareProfessionalType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let referringHealthCareProfessionalType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3604' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referringHealthCareProfessionalType && referringHealthCareProfessionalType[ 0 ] ) {
        return _.get( referringHealthCareProfessionalType[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getConsultationDate( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let consultationDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4117' : 'UHN#3558' )
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDate && consultationDate[ 0 ] ) {
        return _.get( consultationDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getConsultationDecision( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let consultationDecision = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4116' : 'UHN#3559' )  
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDecision && consultationDecision[ 0 ] ) {
        return _.get( consultationDecision[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonCancelled( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonCancelled = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4118' : 'UHN#3560' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonCancelled && reasonCancelled[ 0 ] ) {
        return _.get( reasonCancelled[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getConsultationCancelledDate( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let consultationCancelledDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4269' : 'UHN#4268' )  
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationCancelledDate && consultationCancelledDate[ 0 ] ) {
        return _.get( consultationCancelledDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getReasonDelayed( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonDelayed = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4119' : 'UHN#3561' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonDelayed && reasonDelayed[ 0 ] ) {
        return _.get( reasonDelayed[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getPrimaryTransplantPhysician( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let primaryTransplantPhysician = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#351' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( primaryTransplantPhysician && primaryTransplantPhysician[ 0 ] ) {
        return _.get( primaryTransplantPhysician[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getConsultationDelayStartDate( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let consultationDelayStartDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4120' : 'UHN#3562' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDelayStartDate && consultationDelayStartDate[ 0 ] ) {
        return _.get( consultationDelayStartDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getConsultationDelayEndDate( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let consultationDelayEndDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4121' : 'UHN#3563' )
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDelayEndDate && consultationDelayEndDate[ 0 ] ) {
        return _.get( consultationDelayEndDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getConsultationComments( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let consultationComments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4122' : 'UHN#3564' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationComments && consultationComments[ 0 ] ) {
        return _.get( consultationComments[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getAssessmentDate( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let assessmentDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4103' : 'UHN#3986' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( assessmentDate && assessmentDate[ 0 ]?.resource?.code?.text ) {
        return _.get( assessmentDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getAssessmenDecision( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let assessmentDecision = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4104' : 'UHN#3987' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( assessmentDecision && assessmentDecision[ 0 ] ) {
        return _.get( assessmentDecision[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonAssessmentCancelled( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonAssessmentCancelled = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4105' : 'UHN#3988' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonAssessmentCancelled && reasonAssessmentCancelled[ 0 ] ) {
        return _.get( reasonAssessmentCancelled[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonRecipientNotEligible( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonRecipientNotEligible = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4106' : 'UHN#3989' )
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonRecipientNotEligible && reasonRecipientNotEligible[ 0 ] ) {
        return _.get( reasonRecipientNotEligible[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonFurtherTreatment( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonRecipientNotEligible = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4107' : 'UHN#3990' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonRecipientNotEligible && reasonRecipientNotEligible[ 0 ] ) {
        return _.get( reasonRecipientNotEligible[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getOther( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let other = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4108' : 'UHN#3991' )  
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( other && other[ 0 ] ) {
        return _.get( other[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getAbsoluteContraindication( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        let MED_ABS_CONTRAIND_CODE = 'UHN#3602';

      if ( organ === 'Liver' ) {
        MED_ABS_CONTRAIND_CODE = 'UHN#3787';
      } else if ( organ === 'Lung' ) {
        MED_ABS_CONTRAIND_CODE = 'UHN#3771';
      } else if ( organ === 'Heart' ) {
        MED_ABS_CONTRAIND_CODE = 'UHN#3790';
      } else if ( organ === 'Pancreas' ) {
        MED_ABS_CONTRAIND_CODE = 'UHN#3806';
      } else if ( organ === 'Intestine' ) {
        MED_ABS_CONTRAIND_CODE = 'UHN#3808';
      }
      if( observation && observation[ 0 ] ) {
      let absoluteContraindication = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === MED_ABS_CONTRAIND_CODE
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( absoluteContraindication && absoluteContraindication[ 0 ] ) {
        return _.get( absoluteContraindication[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getRelativeContraindication( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
       let MED_REL_CONTRAIND_CODE = 'UHN#3603';
      if ( organ === 'Lung' ) {
        MED_REL_CONTRAIND_CODE = 'UHN#3772';
      } else if ( organ === 'Heart' ) {
        MED_REL_CONTRAIND_CODE = 'UHN#3791';
      } else if ( organ === 'Pancreas' ) {
        MED_REL_CONTRAIND_CODE = 'UHN#3807';
      }
      if( observation && observation[ 0 ] ) {
        let relativeContraindication = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === MED_REL_CONTRAIND_CODE && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( relativeContraindication && relativeContraindication[ 0 ] ) {
        return _.get( relativeContraindication[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let comments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#293' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( comments && comments[ 0 ] ) {
        return _.get( comments[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getFirstName( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let firstName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3977' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( firstName && firstName[0] ) {
          return _.get( firstName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getLastName( patientBundle ) {
      let observation = patientBundle.entries?.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let lastName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3978' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( lastName && lastName[0] ) {
          return _.get( lastName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getAddress( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let lastName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3979' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( lastName && lastName[0] ) {
          return _.get( lastName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getCity( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let lastName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3980' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( lastName && lastName[0] ) {
          return _.get( lastName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getCountry( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let country = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3982' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( country && country[0] ) {
          const raw = _.get( country[0], 'resource.component[0].valueString' );
          return mapCountryEpicValueToInternalCode( raw );
        }
      }
    },
    getPostalCode( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let country = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3981' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( country && country[0] ) {
          return _.get( country[0], 'resource.component[0].valueString' );
        }
      }
    },
    getState( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let stateObs = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3983' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( stateObs && stateObs[0] ) {
          const raw = _.get( stateObs[0], 'resource.component[0].valueString' );
          return mapProvinceEpicValueToInternalCode( raw );
        }
      }
    },
    getPrimaryDiagnosisOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].failed_organ?.primary_diagnosis
      }
    },
    getSecondaryDiagnosisOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        return journey[ 0 ].failed_organ?.secondary_diagnosis
      }
    },
    getPrimaryDiagnosisDateOATS( patientBundleOATS, organ, patientBundle ) {  
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) { 
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            return _.get( journey?.[ 0 ], 'failed_organ.primary_diagnosis_date', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return _.get( journey?.[ 0 ], 'failed_organ.primary_diagnosis_date', '' );   
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].failed_organ?.primary_diagnosis_date
        }
      }
    },
    getReferringOrganizationNameOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.name
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.name
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.name
        }
      }
    },
    getReferringOrganizationTypeOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let episodePhase = this.getEpisodePhase( patientBundle );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            const typeCode = _.get( journey?.[ 0 ], 'stage_attributes.referral.referrer.organization.type_code', '' );
            if ( typeCode === null || typeCode === undefined || typeCode === '' ) {
              return;
            }
            const codeKey = Number( typeCode );
            if ( Object.prototype.hasOwnProperty.call( REFERRING_ORGANIZATION_TYPE_BY_CODE, codeKey ) ) {
              return REFERRING_ORGANIZATION_TYPE_BY_CODE[codeKey];
            }
            return typeCode;
        
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            const typeCode = _.get( journey?.[ 0 ], 'stage_attributes.referral.referrer.organization.type_code', '' );
            if ( typeCode === null || typeCode === undefined || typeCode === '' ) {
              return;
            }
            const codeKey = Number( typeCode );
            if ( Object.prototype.hasOwnProperty.call( REFERRING_ORGANIZATION_TYPE_BY_CODE, codeKey ) ) {
              return REFERRING_ORGANIZATION_TYPE_BY_CODE[codeKey];
            }
            return typeCode;
          } 
        }
        if( journey.length === 1 ) {
          const typeCode = journey[0].stage_attributes?.referral?.referrer?.organization?.type_code;
            if ( typeCode === null || typeCode === undefined || typeCode === '' ) {
              return;
            }
            const codeKey = Number( typeCode );
            if ( Object.prototype.hasOwnProperty.call( REFERRING_ORGANIZATION_TYPE_BY_CODE, codeKey ) ) {
              return REFERRING_ORGANIZATION_TYPE_BY_CODE[codeKey];
            }
            return typeCode;
        }
      }
    },
    getReferringHealthCareProfessionalTypeOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            const typeCode = _.get( journey?.[ 0 ], 'stage_attributes.referral.referrer.professional.type_code', '' );
        if ( typeCode === null || typeCode === undefined || typeCode === '' ) {
          return;
        }
        const codeKey = Number( typeCode );
        if ( Object.prototype.hasOwnProperty.call( REFERRING_HEALTH_CARE_PROFESSIONAL_TYPE_BY_CODE, codeKey ) ) {
          return REFERRING_HEALTH_CARE_PROFESSIONAL_TYPE_BY_CODE[ codeKey ];
        }
        return typeCode;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            const typeCode = _.get( journey?.[ 0 ], 'stage_attributes.referral.referrer.professional.type_code', '' );
        if ( typeCode === null || typeCode === undefined || typeCode === '' ) {
          return;
        }
        const codeKey = Number( typeCode );
        if ( Object.prototype.hasOwnProperty.call( REFERRING_HEALTH_CARE_PROFESSIONAL_TYPE_BY_CODE, codeKey ) ) {
          return REFERRING_HEALTH_CARE_PROFESSIONAL_TYPE_BY_CODE[ codeKey ];
        }
        return typeCode;
          } 
        }
        if( journey.length === 1 ) {
          const typeCode = journey[ 0 ].stage_attributes?.referral?.referrer?.professional?.type_code;
        if ( typeCode === null || typeCode === undefined || typeCode === '' ) {
          return;
        }
        const codeKey = Number( typeCode );
        if ( Object.prototype.hasOwnProperty.call( REFERRING_HEALTH_CARE_PROFESSIONAL_TYPE_BY_CODE, codeKey ) ) {
          return REFERRING_HEALTH_CARE_PROFESSIONAL_TYPE_BY_CODE[ codeKey ];
        }
        return typeCode;
        }
      }
    },
    getFirstNameOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return _.get( journey?.[ 0 ], 'stage_attributes.referral.referrer.professional.first_name', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.professional?.first_name  
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.referral?.referrer?.professional?.first_name
        }
      }
    },
    getLastNameOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.professional?.last_name
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.professional?.last_name  
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.referral?.referrer?.professional?.last_name
        }
      }
    },
    getAddressOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle ); 
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.street
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.street
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.street
        }
      }
    },
    getCityOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.city
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.city  
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.city
        }
      }
    },
    getPostalCodeOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.postal_code
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.postal_code  
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.postal_code
        }
      }
    },
    getCountryOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.country
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.country  
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.country
        }
      }
    },
    getStateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.province
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.province  
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.referral?.referrer?.organization?.province
        }
      }
    },
    getReferralDecisionDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.factors?.decision_date
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.referral?.factors?.decision_date  
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.referral?.factors?.decision_date
        }
      }
    },
    getReferralDecisionOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );  
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] ) {
            const decisionCode = journey[ 0 ].stage_attributes?.referral?.factors?.decision_code;
            if( decisionCode == null || decisionCode === '' ) {
              return;
            }
            // ValueConversions.REFFERRAL_DECISION (recipient_referral_decision OATS lookup)
            const referralDecisionLabelByCode = {
              '4': 'Referral Accepted',
              '1': 'Referral Information Incomplete',
              '3': 'Referral Declined',
              '5': 'Referral Cancelled',
              '2': 'Referral Deferred',
            };
            const key = String( decisionCode );
            return referralDecisionLabelByCode[ key ] ?? decisionCode;
          }
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] ) {
            const decisionCode = journey[ 0 ].stage_attributes?.referral?.factors?.decision_code;
        if( decisionCode == null || decisionCode === '' ) {
          return;
        }
        // ValueConversions.REFFERRAL_DECISION (recipient_referral_decision OATS lookup)
        const referralDecisionLabelByCode = {
          '4': 'Referral Accepted',
          '1': 'Referral Information Incomplete',
          '3': 'Referral Declined',
          '5': 'Referral Cancelled',
          '2': 'Referral Deferred',
        };
        const key = String( decisionCode );
            return referralDecisionLabelByCode[ key ] ?? decisionCode;
      }
          } 
        }
        if( journey.length === 1 ) {
            const decisionCode = journey[ 0 ].stage_attributes?.referral?.factors?.decision_code;
        if( decisionCode == null || decisionCode === '' ) {
          return;
        }
        // ValueConversions.REFFERRAL_DECISION (recipient_referral_decision OATS lookup)
        const referralDecisionLabelByCode = {
          '4': 'Referral Accepted',
          '1': 'Referral Information Incomplete',
          '3': 'Referral Declined',
          '5': 'Referral Cancelled',
          '2': 'Referral Deferred',
        };
        const key = String( decisionCode );
            return referralDecisionLabelByCode[ key ] ?? decisionCode;
        }
      }
    },
    getReferralReceivedDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );

            return _.get( journey?.[ 0 ], 'stage_attributes.referral.received_date', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.referral.received_date', '' );  
          } 
        }
        if( journey.length === 1 ) {
          return _.get( journey?.[ 0 ], 'stage_attributes.referral.received_date', '' );
        }
      }
    },
    getReferralDecisionReasonOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            const reasonCode = _.get( journey?.[ 0 ], 'stage_attributes.referral.factors.decision_reason_code', '' );
        if( reasonCode == null || reasonCode === '' ) {
          return;
        }
        const decisionCode = journey[ 0 ].stage_attributes?.referral?.factors?.decision_code;
        const reasonKey = String( reasonCode );
        const decisionKey = decisionCode == null || decisionCode === '' ? '' : String( decisionCode );
        if( decisionKey === '3' ) {
          return REFERRAL_DECLINED_REASON_BY_CODE[ reasonKey ] ?? reasonCode;
        }
        if( decisionKey === '5' ) {
          return REFERRAL_CANCELLED_REASON_BY_CODE[ reasonKey ] ?? reasonCode;
        }
        return reasonCode;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            const reasonCode = _.get( journey?.[ 0 ], 'stage_attributes.referral.factors.decision_reason_code', '' );
        if( reasonCode == null || reasonCode === '' ) {
          return;
        }
        const decisionCode = journey[ 0 ].stage_attributes?.referral?.factors?.decision_code;
        const reasonKey = String( reasonCode );
        const decisionKey = decisionCode == null || decisionCode === '' ? '' : String( decisionCode );
        if( decisionKey === '3' ) {
          return REFERRAL_DECLINED_REASON_BY_CODE[ reasonKey ] ?? reasonCode;
        }
        if( decisionKey === '5' ) {
          return REFERRAL_CANCELLED_REASON_BY_CODE[ reasonKey ] ?? reasonCode;
        }
        return reasonCode; 
          } 
        }
        if( journey.length === 1 ) {
          const reasonCode = journey[ 0 ].stage_attributes?.referral?.factors?.decision_reason_code;
        if( reasonCode == null || reasonCode === '' ) {
          return;
        }
        const decisionCode = journey[ 0 ].stage_attributes?.referral?.factors?.decision_code;
        const reasonKey = String( reasonCode );
        const decisionKey = decisionCode == null || decisionCode === '' ? '' : String( decisionCode );
        if( decisionKey === '3' ) {
          return REFERRAL_DECLINED_REASON_BY_CODE[ reasonKey ] ?? reasonCode;
        }
        if( decisionKey === '5' ) {
          return REFERRAL_CANCELLED_REASON_BY_CODE[ reasonKey ] ?? reasonCode;
        }
        return reasonCode;
        }
        
      }
    },
    getReferralDecisionCommentsOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) { 
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.referral.factors.decision_comments', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.referral.factors.decision_comments', '' );
          } 
        }
        if( journey.length === 1 ) {
          return _.get( journey?.[ 0 ], 'stage_attributes.referral.factors.decision_comments', '' );
        }
      }
    },
    getConsultationDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_date', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_date', '' );
          } 
        }
        if( journey.length === 1 ) {
          return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_date', '' );
        }
      }
    },
    getConsultationDecisionOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle ); 
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            const decisionCode = _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_code', '' );
            if( decisionCode == null || decisionCode === '' ) {
              return;
            }
            const key = String( decisionCode ).trim();
            const byCode = CONSULTATION_DECISION_LABEL_BY_CODE[ key ];
            if( byCode ) {
              return byCode;
            }
            const normalized = key.toLowerCase();
            for( const [ epicLower, label ] of CONSULTATION_DECISION_EPIC_TEXT_TO_LABEL ) {
              if( normalized === epicLower ) {
                return label;
              }
            }
            return decisionCode;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            const decisionCode = _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_code', '' );
            if( decisionCode == null || decisionCode === '' ) {
              return;
            }
            const key = String( decisionCode ).trim();
            const byCode = CONSULTATION_DECISION_LABEL_BY_CODE[ key ];
            if( byCode ) {
              return byCode;
            }
            const normalized = key.toLowerCase();
            for( const [ epicLower, label ] of CONSULTATION_DECISION_EPIC_TEXT_TO_LABEL ) {
              if( normalized === epicLower ) {
                return label;
              }
            }
            return decisionCode;
          } 
        }
        if( journey.length === 1 ) {
          const decisionCode = journey[ 0 ].stage_attributes?.assessment?.factors?.consultation_decision_code;
          if( decisionCode == null || decisionCode === '' ) {
            return;
          }
          const key = String( decisionCode ).trim();
          const byCode = CONSULTATION_DECISION_LABEL_BY_CODE[ key ];
          if( byCode ) {
            return byCode;
          }
          const normalized = key.toLowerCase();
          for( const [ epicLower, label ] of CONSULTATION_DECISION_EPIC_TEXT_TO_LABEL ) {
            if( normalized === epicLower ) {
              return label;
            }
          }
          return decisionCode;
          } 
        }
    },
    getReasonCancelledOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      const episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
          }
        }
        if( journey[ 0 ] ) {
          const reasonCode = _.get( journey[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_reason_code', '' );
          if( reasonCode == null || reasonCode === '' ) {
            return;
          }
          const key = String( reasonCode ).trim();
          const byCode = CONSULTATION_CANCEL_REASON_LABEL_BY_CODE[ key ];
          if( byCode ) {
            return byCode;
          }
          const normalized = key.toLowerCase();
          for( const [ epicLower, label ] of CONSULTATION_CANCEL_REASON_EPIC_TEXT_TO_LABEL ) {
            if( normalized === epicLower ) {
              return label;
            }
          }
          return reasonCode;
        }
      }
    },
    getReasonDelayedOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      const episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
          }
        }
        if( journey[ 0 ] ) {
          const reasonCode = _.get( journey[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_reason_code', '' );
          if( reasonCode == null || reasonCode === '' ) {
            return;
          }
          const key = String( reasonCode ).trim();
          const byCode = CONSULTATION_DELAY_REASON_LABEL_BY_CODE[ key ];
          if( byCode ) {
            return byCode;
          }
          const normalized = key.toLowerCase();
          for( const [ epicLower, label ] of CONSULTATION_DELAY_REASON_EPIC_TEXT_TO_LABEL ) {
            if( normalized === epicLower ) {
              return label;
            }
          }
          return reasonCode;
        }
      }
    },
    getPrimaryTransplantPhysicianOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_primary_physician_id', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_primary_physician_id', '' );
          } 
        }
        if( journey.length === 1 ) {
          return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_primary_physician_id', '' );
        }
      }
    },
    getConsultationDelayStartDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_delay_start_date', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_delay_start_date', '' );
          } 
        }
        if( journey.length === 1 ) {
          return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_delay_start_date', '' );
        }
      }
    },
    getConsultationDelayEndDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_delay_end_date', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_delay_end_date', '' );
          } 
        }
        if( journey.length === 1 ) {
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_delay_end_date', '' );
        }
      }
    },
    getConsultationCommentsOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_comments', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_comments', '' );
          } 
        }
        if( journey.length === 1 ) {
          return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.consultation_decision_comments', '' );
        }
      }
    },
    getAssessmentDateOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.assessment_decision_date', '' );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.assessment_decision_date', '' );
          } 
        }
        if( journey.length === 1 ) {
          return _.get( journey?.[ 0 ], 'stage_attributes.assessment.factors.assessment_decision_date', '' );
        }
      }
    },
    getAssessmenDecisionOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      const resolveAssessmentDecisionLabel = ( j ) => {
        const decisionCode = _.get( j?.[ 0 ], 'stage_attributes.assessment.factors.assessment_decision_code', '' );
        if( decisionCode == null || decisionCode === '' ) {
          return;
        }
        const key = String( decisionCode ).trim();
        const byCode = ASSESSMENT_DECISION_LABEL_BY_CODE[ key ];
        if( byCode ) {
          return byCode;
        }
        const normalized = key.toLowerCase();
        for( const [ epicLower, label ] of ASSESSMENT_DECISION_EPIC_TEXT_TO_LABEL ) {
          if( normalized === epicLower ) {
            return label;
          }
        }
        return decisionCode;
      };
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            return resolveAssessmentDecisionLabel( journey );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return resolveAssessmentDecisionLabel( journey );
          }
        }
        if( journey.length === 1 ) {
          return resolveAssessmentDecisionLabel( journey );
        }
      }
    },
    getReasonAssessmentCancelledOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      const episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
          }
        }
        if( journey[ 0 ] ) {
          const reasonCode = _.get( journey[ 0 ], 'stage_attributes.assessment.factors.assessment_decision_reason_code', '' );
          if( reasonCode == null || reasonCode === '' ) {
            return;
          }
          const key = String( reasonCode ).trim();
          const byCode = ASSESSMENT_CANCEL_REASON_LABEL_BY_CODE[ key ];
          if( byCode ) {
            return byCode;
          }
          const normalized = key.toLowerCase();
          for( const [ epicLower, label ] of ASSESSMENT_CANCEL_REASON_EPIC_TEXT_TO_LABEL ) {
            if( normalized === epicLower ) {
              return label;
            }
          }
          return reasonCode;
        }
      }
    },
    getReasonRecipientNotEligibleOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      const episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
          ( n.completed === false ) ) );
          }
        }
        if( journey[ 0 ] ) {
          const reasonCode = _.get( journey[ 0 ], 'stage_attributes.assessment.factors.assessment_decision_reason_code', '' );
          if( reasonCode == null || reasonCode === '' ) {
            return;
          }
          const key = String( reasonCode ).trim();
          const byCode = ASSESSMENT_NOT_ELIGIBLE_REASON_LABEL_BY_CODE[ key ];
          if( byCode ) {
            return byCode;
          }
          const normalized = key.toLowerCase();
          for( const [ epicLower, label ] of ASSESSMENT_NOT_ELIGIBLE_REASON_EPIC_TEXT_TO_LABEL ) {
            if( normalized === epicLower ) {
              return label;
            }
          }
          return reasonCode;
        }
      }
    },
    getReasonFurtherTreatmentOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.assessment?.factors?.assessment_decision_reason_other;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.assessment?.factors?.assessment_decision_reason_other;
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.assessment?.factors?.assessment_decision_reason_other;
        }
      }
    },
    getOtherOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.assessment?.factors?.assessment_decision_reason_other;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.assessment?.factors?.assessment_decision_reason_other;
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.assessment?.factors?.assessment_decision_reason_other;
        }
      }
    },
    getAbsoluteContraindicationOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      const resolveFromJourney = ( j ) => resolveAbsoluteContraindicationOatsDisplay(
        _.get( j?.[ 0 ], 'stage_attributes.assessment.factors.assessment_absolute_contraindication_code', '' ),
        organ,
      );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            return resolveFromJourney( journey );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return resolveFromJourney( journey );
          }
        }
        if( journey.length === 1 ) {
          return resolveFromJourney( journey );
        }
      }
    },
    getRelativeContraindicationOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      const resolveFromJourney = ( j ) => resolveRelativeContraindicationOatsDisplay(
        _.get( j?.[ 0 ], 'stage_attributes.assessment.factors.assessment_relative_contraindication_code', '' ),
        organ,
      );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            return resolveFromJourney( journey );
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            return resolveFromJourney( journey );
          }
        }
        if( journey.length === 1 ) {
          return resolveFromJourney( journey );
        }
      }
    },
    getCommentsOATS( patientBundleOATS, organ, patientBundle ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' ) );
      let episodePhase = this.getEpisodePhase( patientBundle );
      if( journey && journey[ 0 ] ) {
        if( journey.length > 1 ) {
          if( episodePhase > 30 ) {
            journey = journey.filter( ( n ) => ( n.stage === 'transplant' || n.stage === 'post-transplant' ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.assessment?.factors?.assessment_decision_comments;
          } else {
            journey = journey.filter( ( n ) => ( ( n.stage === 'registration' || n.stage === 'referral' || n.stage === 'assessment' || n.stage === 'waitlist' ) &&
            ( n.completed === false ) ) );
            if( journey && journey[ 0 ] )
            return journey[ 0 ].stage_attributes?.assessment?.factors?.assessment_decision_comments;
          } 
        }
        if( journey.length === 1 ) {
          return journey[ 0 ].stage_attributes?.assessment?.factors?.assessment_decision_comments;
        }
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 750px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 3780px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  /* padding-top: 5px; */
  padding-bottom: 10px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
width: 200px;
/* padding-left: 50px; */
}

.inputDisplayCovergage {
border-style: solid;
width: 320px;
background-color: #F2F2F2;
}

.inputDisplayCustom {
border-style: solid;
width: 200px;
border-color: rgb(185, 184, 234);
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  /* padding-top: 5.5px; */
  /* padding-bottom: 2.5px; */
  /* padding-right: 15px; */
  padding-inline-start: 2%;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.mandatory-field label::after) {
  content: " *";
  color: red;
}

:deep(.CoverageClassName .afflo-ds-form-control) {
  width: 360px;
}

:deep(.transplantProgram .afflo-ds-form-control) {
  width: 400px;
} 

:deep(.referralDecisionReason .afflo-ds-form-control) {
  width: 500px;
}
:deep(.consultationDecision .afflo-ds-form-control) {
  width: 320px;
}

:deep(.address .afflo-ds-form-control) {
  width: 450px;
}

:deep(.primaryDiagnosis .afflo-ds-form-control) {
  width: 580px;
}

:deep(.referringOrganizationName .afflo-ds-form-control) {
  width: 370px;
}

:deep(.referringOrganizationType .afflo-ds-form-control) {
  width: 350px;
}

:deep(.consultationComments .afflo-ds-form-control) {
  width: 450px;
}

:deep(.referringHealthCareProfessionalType .afflo-ds-form-control) {
  width: 400px;
}

:deep(.assessmentDecision .afflo-ds-form-control) {
  width: 420px;
} 

.highlightField :deep(.afflo-ds-form-control) {
  border: 2px solid red;
}

:deep(.reasonRecipientNotEligible .afflo-ds-form-control) {
    width: 400px;
}

:deep(.relativeContraindication .afflo-ds-form-control) {
  width: 380px;
}


/* .verticalLine{
  border-left: 6px dotted green;
   height: 20px; 
  height: 50px; 
  position: absolute;
  left: 50%;
  margin-left: -3px;
  top: 0; 
} */

/* .row .col-4:last-child {
  border-left: 2px solid #4C5057;
  padding-left: 80px;
}  */




</style>
